//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import authService, { AuthorizeService } from "../components/api-authorization/AuthorizeService";
import { AccountLevel, ClaimActionType, ClaimScope } from '../config/Levels'
import { ISystemSettings, SystemSettings } from './class_extensions';
import { Config } from "../config/Config";
import dayjs from 'dayjs';
export class AuthorizedApiBase {
    private authService: AuthorizeService;

    protected constructor() {
        this.authService = authService;
    }

    protected transformOptions = async (options: MyAxiosRequestConfig): Promise<MyAxiosRequestConfig> => {
        options.headers = {
            ...options.headers,
            Authorization: 'Bearer ' + await this.authService.getAccessToken()
        };
        return Promise.resolve(options);
    };

    protected getBaseUrl(baseUrl: string) {
        return `${Config.server_url}:${Config.port}`;
    }
}

export class ApprovalFlowsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth)
     * @return Success
     */
    approvalFlowsProgressV1(regardingObjectTypeId: string, regardingObjectId: string, iD: string, dataVersion: number , cancelToken?: CancelToken | undefined): Promise<GetApprovalFlowProgressResponse> {
        let url_ = this.baseUrl + "/api/ApprovalFlows/{regardingObjectTypeId}/{regardingObjectId}/{ID}/{DataVersion}/ApprovalFlowsProgressV1";
        if (regardingObjectTypeId === undefined || regardingObjectTypeId === null)
            throw new Error("The parameter 'regardingObjectTypeId' must be defined.");
        url_ = url_.replace("{regardingObjectTypeId}", encodeURIComponent("" + regardingObjectTypeId));
        if (regardingObjectId === undefined || regardingObjectId === null)
            throw new Error("The parameter 'regardingObjectId' must be defined.");
        url_ = url_.replace("{regardingObjectId}", encodeURIComponent("" + regardingObjectId));
        if (iD === undefined || iD === null)
            throw new Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        if (dataVersion === undefined || dataVersion === null)
            throw new Error("The parameter 'dataVersion' must be defined.");
        url_ = url_.replace("{DataVersion}", encodeURIComponent("" + dataVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovalFlowsProgressV1(_response);
        });
    }

    protected processApprovalFlowsProgressV1(response: AxiosResponse): Promise<GetApprovalFlowProgressResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetApprovalFlowProgressResponse.fromJS(resultData200);
            return Promise.resolve<GetApprovalFlowProgressResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApprovalFlowProgressResponse>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    getProjectApprovalFlows(  cancelToken?: CancelToken | undefined): Promise<GetApprovalFlowsHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/ApprovalFlows/GetProjectApprovalFlows";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectApprovalFlows(_response);
        });
    }

    protected processGetProjectApprovalFlows(response: AxiosResponse): Promise<GetApprovalFlowsHistoryResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApprovalFlowsHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetApprovalFlowsHistoryResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApprovalFlowsHistoryResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    getUserApprovalFlows(  cancelToken?: CancelToken | undefined): Promise<GetApprovalFlowsHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/ApprovalFlows/GetUserApprovalFlows";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserApprovalFlows(_response);
        });
    }

    protected processGetUserApprovalFlows(response: AxiosResponse): Promise<GetApprovalFlowsHistoryResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApprovalFlowsHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetApprovalFlowsHistoryResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApprovalFlowsHistoryResponse[]>(null as any);
    }
}

export class ApprovalFlowsHistoryClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth)
     * @return Success
     */
    approvalFlowsHistory(regardingObjectId: string , cancelToken?: CancelToken | undefined): Promise<GetApprovalFlowsHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/ApprovalFlowsHistory/{regardingObjectId}/ApprovalFlowsHistory";
        if (regardingObjectId === undefined || regardingObjectId === null)
            throw new Error("The parameter 'regardingObjectId' must be defined.");
        url_ = url_.replace("{regardingObjectId}", encodeURIComponent("" + regardingObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovalFlowsHistory(_response);
        });
    }

    protected processApprovalFlowsHistory(response: AxiosResponse): Promise<GetApprovalFlowsHistoryResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetApprovalFlowsHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetApprovalFlowsHistoryResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApprovalFlowsHistoryResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    approveApprovalFlow(body?: UpdateUserApprovalFlowHistoryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlowsHistory/ApproveApprovalFlow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveApprovalFlow(_response);
        });
    }

    protected processApproveApprovalFlow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    approveApprovalFlowV1(body?: UpdateUserApprovalFlowHistoryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlowsHistory/ApproveApprovalFlowV1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveApprovalFlowV1(_response);
        });
    }

    protected processApproveApprovalFlowV1(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    cancelApprovalFlow(body?: UpdateUserApprovalFlowHistoryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlowsHistory/CancelApprovalFlow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelApprovalFlow(_response);
        });
    }

    protected processCancelApprovalFlow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    cancelApprovalFlowV1(body?: UpdateUserApprovalFlowHistoryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlowsHistory/CancelApprovalFlowV1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelApprovalFlowV1(_response);
        });
    }

    protected processCancelApprovalFlowV1(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    triggerApprovalFlow(body?: TriggerApprovalFlowHistoryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ApprovalFlowsHistory/TriggerApprovalFlow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTriggerApprovalFlow(_response);
        });
    }

    protected processTriggerApprovalFlow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApproveTemplateAnswersClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: LegalTech.ResourceProcess;LegalTech.ActionNamePUT, user:exists)
     * @param body (optional) 
     * @return Success
     */
    approveTemplateAnswers(body?: ApproveTemplateAnswersRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ApproveTemplateAnswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveTemplateAnswers(_response);
        });
    }

    protected processApproveTemplateAnswers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomEntityValuesClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    customEntityValuesPost(body?: CreateCustomEntityValueRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CustomEntityValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomEntityValuesPost(_response);
        });
    }

    protected processCustomEntityValuesPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    customEntityValuesPut(body?: UpdateCustomEntityValueRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CustomEntityValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomEntityValuesPut(_response);
        });
    }

    protected processCustomEntityValuesPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    customEntityValuesDelete(body?: DeleteCustomEntityValueRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CustomEntityValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomEntityValuesDelete(_response);
        });
    }

    protected processCustomEntityValuesDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    customEntityValuesGet(id: string , cancelToken?: CancelToken | undefined): Promise<GetCustomEntityValueResponse> {
        let url_ = this.baseUrl + "/api/CustomEntityValues/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomEntityValuesGet(_response);
        });
    }

    protected processCustomEntityValuesGet(response: AxiosResponse): Promise<GetCustomEntityValueResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomEntityValueResponse.fromJS(resultData200);
            return Promise.resolve<GetCustomEntityValueResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomEntityValueResponse>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    customEntityValuesGetByRegardingObjectTypeId(regardingObjectTypeId: string , cancelToken?: CancelToken | undefined): Promise<GetCustomEntityValueResponse[]> {
        let url_ = this.baseUrl + "/api/CustomEntityValues/{regardingObjectTypeId}/CustomEntityValuesGetByRegardingObjectTypeId";
        if (regardingObjectTypeId === undefined || regardingObjectTypeId === null)
            throw new Error("The parameter 'regardingObjectTypeId' must be defined.");
        url_ = url_.replace("{regardingObjectTypeId}", encodeURIComponent("" + regardingObjectTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomEntityValuesGetByRegardingObjectTypeId(_response);
        });
    }

    protected processCustomEntityValuesGetByRegardingObjectTypeId(response: AxiosResponse): Promise<GetCustomEntityValueResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCustomEntityValueResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetCustomEntityValueResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomEntityValueResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    customEntityValuesWithCustomField(regardingObjectTypeId: string , cancelToken?: CancelToken | undefined): Promise<GetCustomEntityValueResponse[]> {
        let url_ = this.baseUrl + "/api/CustomEntityValues/{regardingObjectTypeId}/CustomEntityValuesWithCustomField";
        if (regardingObjectTypeId === undefined || regardingObjectTypeId === null)
            throw new Error("The parameter 'regardingObjectTypeId' must be defined.");
        url_ = url_.replace("{regardingObjectTypeId}", encodeURIComponent("" + regardingObjectTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomEntityValuesWithCustomField(_response);
        });
    }

    protected processCustomEntityValuesWithCustomField(response: AxiosResponse): Promise<GetCustomEntityValueResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCustomEntityValueResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetCustomEntityValueResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomEntityValueResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    multiple(body?: UpdateMultipleProcessesRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CustomEntityValues/Multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMultiple(_response);
        });
    }

    protected processMultiple(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomFieldsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    updateCustomFieldValue(body?: UpdateCustomFieldValueRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UpdateCustomFieldResponse> {
        let url_ = this.baseUrl + "/api/CustomFields/UpdateCustomFieldValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomFieldValue(_response);
        });
    }

    protected processUpdateCustomFieldValue(response: AxiosResponse): Promise<UpdateCustomFieldResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateCustomFieldResponse.fromJS(resultData200);
            return Promise.resolve<UpdateCustomFieldResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateCustomFieldResponse>(null as any);
    }
}

export class DashboardsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth)
     * @return Success
     */
    getAllSectionsProcesses(  cancelToken?: CancelToken | undefined): Promise<GetDashboardResponse> {
        let url_ = this.baseUrl + "/api/Dashboards/GetAllSectionsProcesses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSectionsProcesses(_response);
        });
    }

    protected processGetAllSectionsProcesses(response: AxiosResponse): Promise<GetDashboardResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDashboardResponse.fromJS(resultData200);
            return Promise.resolve<GetDashboardResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDashboardResponse>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    getDashboardProcesses(  cancelToken?: CancelToken | undefined): Promise<GetDashboardProcess[]> {
        let url_ = this.baseUrl + "/api/Dashboards/GetDashboardProcesses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDashboardProcesses(_response);
        });
    }

    protected processGetDashboardProcesses(response: AxiosResponse): Promise<GetDashboardProcess[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetDashboardProcess.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetDashboardProcess[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDashboardProcess[]>(null as any);
    }
}

export class FlowengineHistoryLogsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth)
     * @param flowEngineID (optional) 
     * @return Success
     */
    flowEngineHistoryLogs(flowEngineID?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/FlowengineHistoryLogs/FlowEngineHistoryLogs?";
        if (flowEngineID === null)
            throw new Error("The parameter 'flowEngineID' cannot be null.");
        else if (flowEngineID !== undefined)
            url_ += "FlowEngineID=" + encodeURIComponent("" + flowEngineID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFlowEngineHistoryLogs(_response);
        });
    }

    protected processFlowEngineHistoryLogs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param flowEngineHistoryLogID (optional) 
     * @param stepID (optional) 
     * @return Success
     */
    getApprovalFlowHistoryLogs(flowEngineHistoryLogID?: string | undefined, stepID?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/FlowengineHistoryLogs/GetApprovalFlowHistoryLogs?";
        if (flowEngineHistoryLogID === null)
            throw new Error("The parameter 'flowEngineHistoryLogID' cannot be null.");
        else if (flowEngineHistoryLogID !== undefined)
            url_ += "FlowEngineHistoryLogID=" + encodeURIComponent("" + flowEngineHistoryLogID) + "&";
        if (stepID === null)
            throw new Error("The parameter 'stepID' cannot be null.");
        else if (stepID !== undefined)
            url_ += "StepID=" + encodeURIComponent("" + stepID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovalFlowHistoryLogs(_response);
        });
    }

    protected processGetApprovalFlowHistoryLogs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param flowEngineHistoryLogID (optional) 
     * @return Success
     */
    getFlowEngineStepsHistoryLogs(flowEngineHistoryLogID?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/FlowengineHistoryLogs/GetFlowEngineStepsHistoryLogs?";
        if (flowEngineHistoryLogID === null)
            throw new Error("The parameter 'flowEngineHistoryLogID' cannot be null.");
        else if (flowEngineHistoryLogID !== undefined)
            url_ += "FlowEngineHistoryLogID=" + encodeURIComponent("" + flowEngineHistoryLogID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlowEngineStepsHistoryLogs(_response);
        });
    }

    protected processGetFlowEngineStepsHistoryLogs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrganizationsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth)
     * @return Success
     */
    projectsGetByCompanyId(companyId: string , cancelToken?: CancelToken | undefined): Promise<GetAllOrganizationsResponse[]> {
        let url_ = this.baseUrl + "/api/Organizations/{companyId}/ProjectsGetByCompanyId";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectsGetByCompanyId(_response);
        });
    }

    protected processProjectsGetByCompanyId(response: AxiosResponse): Promise<GetAllOrganizationsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllOrganizationsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllOrganizationsResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrganizationsResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    organizations(id: string , cancelToken?: CancelToken | undefined): Promise<GetOrganizationResponse> {
        let url_ = this.baseUrl + "/api/Organizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizations(_response);
        });
    }

    protected processOrganizations(response: AxiosResponse): Promise<GetOrganizationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrganizationResponse.fromJS(resultData200);
            return Promise.resolve<GetOrganizationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrganizationResponse>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    companiesGetByPartnerId(partnerId: string , cancelToken?: CancelToken | undefined): Promise<GetAllOrganizationsResponse[]> {
        let url_ = this.baseUrl + "/api/Organizations/{partnerId}/CompaniesGetByPartnerId";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompaniesGetByPartnerId(_response);
        });
    }

    protected processCompaniesGetByPartnerId(response: AxiosResponse): Promise<GetAllOrganizationsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllOrganizationsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllOrganizationsResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrganizationsResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    partnerProjects(partnerId: string , cancelToken?: CancelToken | undefined): Promise<GetAllOrganizationsResponse[]> {
        let url_ = this.baseUrl + "/api/Organizations/{partnerId}/PartnerProjects";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerProjects(_response);
        });
    }

    protected processPartnerProjects(response: AxiosResponse): Promise<GetAllOrganizationsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllOrganizationsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllOrganizationsResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrganizationsResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    changeProject(projectId: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/ChangeProject/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeProject(_response);
        });
    }

    protected processChangeProject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    changeUserDefaultLanguage(body?: ChangeUserDefaultLanguageRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/ChangeUserDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserDefaultLanguage(_response);
        });
    }

    protected processChangeUserDefaultLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    changeUserDefaultOrganization(body?: ChangeUserDefaultOrganizationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/ChangeUserDefaultOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserDefaultOrganization(_response);
        });
    }

    protected processChangeUserDefaultOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    changeUserFavoriteOrganization(body?: ChangeUserFavoriteOrganizationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/ChangeUserFavoriteOrganization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserFavoriteOrganization(_response);
        });
    }

    protected processChangeUserFavoriteOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    changeUserFavoritePartner(body?: ChangeUserFavoritePartnerRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/ChangeUserFavoritePartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserFavoritePartner(_response);
        });
    }

    protected processChangeUserFavoritePartner(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper)
     * @return Success
     */
    companies(  cancelToken?: CancelToken | undefined): Promise<GetAllPartnersResponse[]> {
        let url_ = this.baseUrl + "/api/Organizations/Companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompanies(_response);
        });
    }

    protected processCompanies(response: AxiosResponse): Promise<GetAllPartnersResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllPartnersResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllPartnersResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllPartnersResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    companyPost(body?: CreateCompanyRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/Company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompanyPost(_response);
        });
    }

    protected processCompanyPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    companyPut(body?: UpdateCompanyRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/Company";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompanyPut(_response);
        });
    }

    protected processCompanyPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    getUserDefaultOrganization(  cancelToken?: CancelToken | undefined): Promise<GetUserDefaultOrganizationResponse> {
        let url_ = this.baseUrl + "/api/Organizations/GetUserDefaultOrganization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserDefaultOrganization(_response);
        });
    }

    protected processGetUserDefaultOrganization(response: AxiosResponse): Promise<GetUserDefaultOrganizationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserDefaultOrganizationResponse.fromJS(resultData200);
            return Promise.resolve<GetUserDefaultOrganizationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserDefaultOrganizationResponse>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    getUserFavoriteOrganizations(  cancelToken?: CancelToken | undefined): Promise<GetUserOrganizationsResponse> {
        let url_ = this.baseUrl + "/api/Organizations/GetUserFavoriteOrganizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserFavoriteOrganizations(_response);
        });
    }

    protected processGetUserFavoriteOrganizations(response: AxiosResponse): Promise<GetUserOrganizationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserOrganizationsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserOrganizationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserOrganizationsResponse>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    getUserFavoritePartners(  cancelToken?: CancelToken | undefined): Promise<GetUserOrganizationsResponse> {
        let url_ = this.baseUrl + "/api/Organizations/GetUserFavoritePartners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserFavoritePartners(_response);
        });
    }

    protected processGetUserFavoritePartners(response: AxiosResponse): Promise<GetUserOrganizationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserOrganizationsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserOrganizationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserOrganizationsResponse>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    partnerPost(body?: CreatePartnerRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/Partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerPost(_response);
        });
    }

    protected processPartnerPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    partnerPut(body?: UpdatePartnerRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/Partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerPut(_response);
        });
    }

    protected processPartnerPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    partners(  cancelToken?: CancelToken | undefined): Promise<GetAllPartnersResponse[]> {
        let url_ = this.baseUrl + "/api/Organizations/Partners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartners(_response);
        });
    }

    protected processPartners(response: AxiosResponse): Promise<GetAllPartnersResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllPartnersResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllPartnersResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllPartnersResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    projectPost(body?: CreateProjectRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/Project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectPost(_response);
        });
    }

    protected processProjectPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    projectPut(body?: UpdateProjectRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Organizations/Project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectPut(_response);
        });
    }

    protected processProjectPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    projectGet(id: string , cancelToken?: CancelToken | undefined): Promise<GetOrganizationResponse> {
        let url_ = this.baseUrl + "/api/Organizations/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectGet(_response);
        });
    }

    protected processProjectGet(response: AxiosResponse): Promise<GetOrganizationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrganizationResponse.fromJS(resultData200);
            return Promise.resolve<GetOrganizationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrganizationResponse>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper)
     * @return Success
     */
    projects(  cancelToken?: CancelToken | undefined): Promise<GetAllOrganizationsResponse[]> {
        let url_ = this.baseUrl + "/api/Organizations/Projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjects(_response);
        });
    }

    protected processProjects(response: AxiosResponse): Promise<GetAllOrganizationsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllOrganizationsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllOrganizationsResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrganizationsResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    templateProjects(  cancelToken?: CancelToken | undefined): Promise<GetAllOrganizationsResponse[]> {
        let url_ = this.baseUrl + "/api/Organizations/TemplateProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTemplateProjects(_response);
        });
    }

    protected processTemplateProjects(response: AxiosResponse): Promise<GetAllOrganizationsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllOrganizationsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllOrganizationsResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrganizationsResponse[]>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    userPartnerOrCompanyProjects(  cancelToken?: CancelToken | undefined): Promise<GetUserOrganizationsResponse> {
        let url_ = this.baseUrl + "/api/Organizations/UserPartnerOrCompanyProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserPartnerOrCompanyProjects(_response);
        });
    }

    protected processUserPartnerOrCompanyProjects(response: AxiosResponse): Promise<GetUserOrganizationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserOrganizationsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserOrganizationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserOrganizationsResponse>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    userPartners(  cancelToken?: CancelToken | undefined): Promise<GetAllOrganizationsResponse> {
        let url_ = this.baseUrl + "/api/Organizations/UserPartners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserPartners(_response);
        });
    }

    protected processUserPartners(response: AxiosResponse): Promise<GetAllOrganizationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllOrganizationsResponse.fromJS(resultData200);
            return Promise.resolve<GetAllOrganizationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrganizationsResponse>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    userProjects(  cancelToken?: CancelToken | undefined): Promise<GetAllOrganizationsResponse> {
        let url_ = this.baseUrl + "/api/Organizations/UserProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserProjects(_response);
        });
    }

    protected processUserProjects(response: AxiosResponse): Promise<GetAllOrganizationsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllOrganizationsResponse.fromJS(resultData200);
            return Promise.resolve<GetAllOrganizationsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrganizationsResponse>(null as any);
    }
}

export class RiskAssesmentClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * Used to get entire risk list (Auth)
     * @return Success
     */
    getRiskAssesments(  cancelToken?: CancelToken | undefined): Promise<RiskAssessmentModel[]> {
        let url_ = this.baseUrl + "/api/platform/RiskAssesment/GetRiskAssesments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRiskAssesments(_response);
        });
    }

    protected processGetRiskAssesments(response: AxiosResponse): Promise<RiskAssessmentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskAssessmentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RiskAssessmentModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RiskAssessmentModel[]>(null as any);
    }
}

export class ProcessesClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: LegalTech.ResourceProcess;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    processes(id: string , cancelToken?: CancelToken | undefined): Promise<GetProcessResponse> {
        let url_ = this.baseUrl + "/api/Processes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses(_response);
        });
    }

    protected processProcesses(response: AxiosResponse): Promise<GetProcessResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProcessResponse.fromJS(resultData200);
            return Promise.resolve<GetProcessResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProcessResponse>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceProcess;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    processTranslations(id: string , cancelToken?: CancelToken | undefined): Promise<GetProcessTranslationResponse[]> {
        let url_ = this.baseUrl + "/api/Processes/{id}/ProcessTranslations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessTranslations(_response);
        });
    }

    protected processProcessTranslations(response: AxiosResponse): Promise<GetProcessTranslationResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetProcessTranslationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetProcessTranslationResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProcessTranslationResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceProcess;LegalTech.ActionNameDELETE, user:exists)
     * @param body (optional) 
     * @return Success
     */
    deleteProcessTranslation(body?: DeleteProcessTranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Processes/DeleteProcessTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProcessTranslation(_response);
        });
    }

    protected processDeleteProcessTranslation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceProcess;LegalTech.ActionNamePUT, user:exists)
     * @param body (optional) 
     * @return Success
     */
    multiplePut(body?: UpdateMultipleProcessesRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Processes/Multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMultiplePut(_response);
        });
    }

    protected processMultiplePut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceProcess;LegalTech.ActionNameDELETE, user:exists)
     * @param body (optional) 
     * @return Success
     */
    multipleDelete(body?: DeleteMultipleProcessesRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Processes/Multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMultipleDelete(_response);
        });
    }

    protected processMultipleDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class QuestionAnswersClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    questionAnswersPost(body?: CreateQuestionAnswerRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/QuestionAnswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionAnswersPost(_response);
        });
    }

    protected processQuestionAnswersPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth)
     * @return Success
     */
    questionAnswersGet(id: string , cancelToken?: CancelToken | undefined): Promise<GetRegardingObjectQuestionAnswersResponse[]> {
        let url_ = this.baseUrl + "/api/QuestionAnswers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionAnswersGet(_response);
        });
    }

    protected processQuestionAnswersGet(response: AxiosResponse): Promise<GetRegardingObjectQuestionAnswersResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRegardingObjectQuestionAnswersResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetRegardingObjectQuestionAnswersResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRegardingObjectQuestionAnswersResponse[]>(null as any);
    }
}

export class QuestionsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: IsDeveloper, user:exists)
     * @param body (optional) 
     * @return Success
     */
    questionsPost(body?: CreateQuestionRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionsPost(_response);
        });
    }

    protected processQuestionsPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper, user:exists)
     * @param body (optional) 
     * @return Success
     */
    questionsPut(body?: UpdateQuestionRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionsPut(_response);
        });
    }

    protected processQuestionsPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper, user:exists)
     * @param body (optional) 
     * @return Success
     */
    questionsDelete(body?: DeleteQuestionRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionsDelete(_response);
        });
    }

    protected processQuestionsDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper, user:exists)
     * @return Success
     */
    questionsGet(id: string , cancelToken?: CancelToken | undefined): Promise<GetQuestionResponse> {
        let url_ = this.baseUrl + "/api/Questions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionsGet(_response);
        });
    }

    protected processQuestionsGet(response: AxiosResponse): Promise<GetQuestionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetQuestionResponse.fromJS(resultData200);
            return Promise.resolve<GetQuestionResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetQuestionResponse>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper, user:exists)
     * @param body (optional) 
     * @return Success
     */
    deleteQuestionTranslation(body?: DeleteQuestionTranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Questions/DeleteQuestionTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteQuestionTranslation(_response);
        });
    }

    protected processDeleteQuestionTranslation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper, user:exists)
     * @return Success
     */
    getAllQuestion(  cancelToken?: CancelToken | undefined): Promise<GetAllQuestionResponse[]> {
        let url_ = this.baseUrl + "/api/Questions/GetAllQuestion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllQuestion(_response);
        });
    }

    protected processGetAllQuestion(response: AxiosResponse): Promise<GetAllQuestionResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllQuestionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllQuestionResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllQuestionResponse[]>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper, user:exists)
     * @param body (optional) 
     * @return Success
     */
    translationsPost(body?: CreateQuestionTranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Questions/Translations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslationsPost(_response);
        });
    }

    protected processTranslationsPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper, user:exists)
     * @param body (optional) 
     * @return Success
     */
    translationsPut(body?: UpdateQuestionTranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Questions/Translations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslationsPut(_response);
        });
    }

    protected processTranslationsPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RegardingObjectTypesClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    regardingObjectTypes(id: string , cancelToken?: CancelToken | undefined): Promise<GetRegardingObjectTypeResponse> {
        let url_ = this.baseUrl + "/api/RegardingObjectTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegardingObjectTypes(_response);
        });
    }

    protected processRegardingObjectTypes(response: AxiosResponse): Promise<GetRegardingObjectTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRegardingObjectTypeResponse.fromJS(resultData200);
            return Promise.resolve<GetRegardingObjectTypeResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRegardingObjectTypeResponse>(null as any);
    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    menuRegardingObjectTypes(  cancelToken?: CancelToken | undefined): Promise<GetRegardingObjectTypeResponse[]> {
        let url_ = this.baseUrl + "/api/RegardingObjectTypes/MenuRegardingObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMenuRegardingObjectTypes(_response);
        });
    }

    protected processMenuRegardingObjectTypes(response: AxiosResponse): Promise<GetRegardingObjectTypeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRegardingObjectTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetRegardingObjectTypeResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRegardingObjectTypeResponse[]>(null as any);
    }
}

export class ReportsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param organizationId (optional) 
     * @param language (optional) 
     * @return Success
     */
    createUpdateCompanyReport(organizationId?: string | undefined, language?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Reports/CreateUpdateCompanyReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (organizationId === null || organizationId === undefined)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else
            content_.append("OrganizationId", organizationId.toString());
        if (language === null || language === undefined)
            throw new Error("The parameter 'language' cannot be null.");
        else
            content_.append("Language", language.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUpdateCompanyReport(_response);
        });
    }

    protected processCreateUpdateCompanyReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param id (optional) 
     * @param organizationId (optional) 
     * @param language (optional) 
     * @return Success
     */
    createUpdateSingleProcessReport(id?: string | undefined, organizationId?: string | undefined, language?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Reports/CreateUpdateSingleProcessReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (organizationId === null || organizationId === undefined)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else
            content_.append("OrganizationId", organizationId.toString());
        if (language === null || language === undefined)
            throw new Error("The parameter 'language' cannot be null.");
        else
            content_.append("Language", language.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUpdateSingleProcessReport(_response);
        });
    }

    protected processCreateUpdateSingleProcessReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    downloadEntityReportGet(typeId: string, entityId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/DownloadEntityReport/{TypeId}/{EntityId}";
        if (typeId === undefined || typeId === null)
            throw new Error("The parameter 'typeId' must be defined.");
        url_ = url_.replace("{TypeId}", encodeURIComponent("" + typeId));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{EntityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadEntityReportGet(_response);
        });
    }

    protected processDownloadEntityReportGet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    downloadEntityReportGetById(typeId: string, entityId: string, reportId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/DownloadEntityReport/{TypeId}/{EntityId}/{ReportId}";
        if (typeId === undefined || typeId === null)
            throw new Error("The parameter 'typeId' must be defined.");
        url_ = url_.replace("{TypeId}", encodeURIComponent("" + typeId));
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{EntityId}", encodeURIComponent("" + entityId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{ReportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadEntityReportGetById(_response);
        });
    }

    protected processDownloadEntityReportGetById(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    proejct(projectId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/DownloadEntityReport/Proejct/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProejct(_response);
        });
    }

    protected processProejct(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param id (optional) 
     * @return Success
     */
    downloadOrganizationReport(id?: string | undefined , cancelToken?: CancelToken | undefined): Promise<DownloadOrganizationReportResponse> {
        let url_ = this.baseUrl + "/api/Reports/DownloadOrganizationReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadOrganizationReport(_response);
        });
    }

    protected processDownloadOrganizationReport(response: AxiosResponse): Promise<DownloadOrganizationReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadOrganizationReportResponse.fromJS(resultData200);
            return Promise.resolve<DownloadOrganizationReportResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadOrganizationReportResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    downloadSingleProcessReport(id: string , cancelToken?: CancelToken | undefined): Promise<DownloadSingleProcessReportResponse> {
        let url_ = this.baseUrl + "/api/Reports/DownloadSingleProcessReport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSingleProcessReport(_response);
        });
    }

    protected processDownloadSingleProcessReport(response: AxiosResponse): Promise<DownloadSingleProcessReportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadSingleProcessReportResponse.fromJS(resultData200);
            return Promise.resolve<DownloadSingleProcessReportResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadSingleProcessReportResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    projectReportByReportId(projectId: string, reportId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reports/ProjectReportByReportId/{ProjectId}/{ReportId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{ReportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectReportByReportId(_response);
        });
    }

    protected processProjectReportByReportId(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ReportsHistoryClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    reportsHistory(body?: DeleteRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ReportsHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportsHistory(_response);
        });
    }

    protected processReportsHistory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    reportHistories(orgId: string, type: string , cancelToken?: CancelToken | undefined): Promise<ReportHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/ReportsHistory/{orgId}/{type}/ReportHistories";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportHistories(_response);
        });
    }

    protected processReportHistories(response: AxiosResponse): Promise<ReportHistoryResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReportHistoryResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportHistoryResponse[]>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    download(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportsHistory/download/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ReportTemplatesClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param file (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param language (optional) 
     * @param wizardId (optional) 
     * @param organizationId (optional) 
     * @return Success
     */
    reportTemplatesPost(file?: FileParameter | undefined, name?: string | undefined, description?: string | undefined, language?: string | undefined, wizardId?: string | undefined, organizationId?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ReportTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (language === null || language === undefined)
            throw new Error("The parameter 'language' cannot be null.");
        else
            content_.append("Language", language.toString());
        if (wizardId === null || wizardId === undefined)
            throw new Error("The parameter 'wizardId' cannot be null.");
        else
            content_.append("WizardId", wizardId.toString());
        if (organizationId === null || organizationId === undefined)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else
            content_.append("OrganizationId", organizationId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportTemplatesPost(_response);
        });
    }

    protected processReportTemplatesPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param id (optional) 
     * @param file (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @param language (optional) 
     * @param wizardId (optional) 
     * @param organizationId (optional) 
     * @return Success
     */
    reportTemplatesPut(id?: string | undefined, file?: FileParameter | undefined, name?: string | undefined, description?: string | undefined, language?: string | undefined, wizardId?: string | undefined, organizationId?: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ReportTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (description === null || description === undefined)
            throw new Error("The parameter 'description' cannot be null.");
        else
            content_.append("Description", description.toString());
        if (language === null || language === undefined)
            throw new Error("The parameter 'language' cannot be null.");
        else
            content_.append("Language", language.toString());
        if (wizardId === null || wizardId === undefined)
            throw new Error("The parameter 'wizardId' cannot be null.");
        else
            content_.append("WizardId", wizardId.toString());
        if (organizationId === null || organizationId === undefined)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else
            content_.append("OrganizationId", organizationId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportTemplatesPut(_response);
        });
    }

    protected processReportTemplatesPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    reportTemplatesDelete(body?: DeleteReportTemplateRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ReportTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportTemplatesDelete(_response);
        });
    }

    protected processReportTemplatesDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    reportTemplatesGet(id: string , cancelToken?: CancelToken | undefined): Promise<GetReportTemplateResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportTemplatesGet(_response);
        });
    }

    protected processReportTemplatesGet(response: AxiosResponse): Promise<GetReportTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetReportTemplateResponse.fromJS(resultData200);
            return Promise.resolve<GetReportTemplateResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportTemplateResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    companyReportTemplates(organizationId: string , cancelToken?: CancelToken | undefined): Promise<GetReportTemplateResponse[]> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{organizationId}/CompanyReportTemplates";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompanyReportTemplates(_response);
        });
    }

    protected processCompanyReportTemplates(response: AxiosResponse): Promise<GetReportTemplateResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReportTemplateResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetReportTemplateResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportTemplateResponse[]>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    wizardReportTemplates(wizardId: string , cancelToken?: CancelToken | undefined): Promise<GetReportTemplateResponse[]> {
        let url_ = this.baseUrl + "/api/ReportTemplates/{wizardId}/WizardReportTemplates";
        if (wizardId === undefined || wizardId === null)
            throw new Error("The parameter 'wizardId' must be defined.");
        url_ = url_.replace("{wizardId}", encodeURIComponent("" + wizardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWizardReportTemplates(_response);
        });
    }

    protected processWizardReportTemplates(response: AxiosResponse): Promise<GetReportTemplateResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReportTemplateResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetReportTemplateResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportTemplateResponse[]>(null as any);
    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    downloadReportTemplate(reportTemplateId: string , cancelToken?: CancelToken | undefined): Promise<DownloadReportTemplateResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/DownloadReportTemplate/{reportTemplateId}";
        if (reportTemplateId === undefined || reportTemplateId === null)
            throw new Error("The parameter 'reportTemplateId' must be defined.");
        url_ = url_.replace("{reportTemplateId}", encodeURIComponent("" + reportTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadReportTemplate(_response);
        });
    }

    protected processDownloadReportTemplate(response: AxiosResponse): Promise<DownloadReportTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadReportTemplateResponse.fromJS(resultData200);
            return Promise.resolve<DownloadReportTemplateResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadReportTemplateResponse>(null as any);
    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    reportJson(regardingObjectId: string, regardingObjectTypeId: string, organizationId: string , cancelToken?: CancelToken | undefined): Promise<ReportJson> {
        let url_ = this.baseUrl + "/api/ReportTemplates/ReportJson/{regardingObjectId}/{regardingObjectTypeId}/{organizationId}";
        if (regardingObjectId === undefined || regardingObjectId === null)
            throw new Error("The parameter 'regardingObjectId' must be defined.");
        url_ = url_.replace("{regardingObjectId}", encodeURIComponent("" + regardingObjectId));
        if (regardingObjectTypeId === undefined || regardingObjectTypeId === null)
            throw new Error("The parameter 'regardingObjectTypeId' must be defined.");
        url_ = url_.replace("{regardingObjectTypeId}", encodeURIComponent("" + regardingObjectTypeId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportJson(_response);
        });
    }

    protected processReportJson(response: AxiosResponse): Promise<ReportJson> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportJson.fromJS(resultData200);
            return Promise.resolve<ReportJson>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportJson>(null as any);
    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    reportJsonMachine(regardingObjectId: string, regardingObjectTypeId: string, organizationId: string , cancelToken?: CancelToken | undefined): Promise<ReportJsonMachine> {
        let url_ = this.baseUrl + "/api/ReportTemplates/ReportJsonMachine/{regardingObjectId}/{regardingObjectTypeId}/{organizationId}";
        if (regardingObjectId === undefined || regardingObjectId === null)
            throw new Error("The parameter 'regardingObjectId' must be defined.");
        url_ = url_.replace("{regardingObjectId}", encodeURIComponent("" + regardingObjectId));
        if (regardingObjectTypeId === undefined || regardingObjectTypeId === null)
            throw new Error("The parameter 'regardingObjectTypeId' must be defined.");
        url_ = url_.replace("{regardingObjectTypeId}", encodeURIComponent("" + regardingObjectTypeId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportJsonMachine(_response);
        });
    }

    protected processReportJsonMachine(response: AxiosResponse): Promise<ReportJsonMachine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportJsonMachine.fromJS(resultData200);
            return Promise.resolve<ReportJsonMachine>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportJsonMachine>(null as any);
    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    project(organizationId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReportTemplates/ReportJsonMachine/Project/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProject(_response);
        });
    }

    protected processProject(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class RolesClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    rolesPost(body?: CreateRoleRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRolesPost(_response);
        });
    }

    protected processRolesPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    rolesPut(body?: UpdateRoleRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRolesPut(_response);
        });
    }

    protected processRolesPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    rolesDelete(body?: DeleteRoleRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRolesDelete(_response);
        });
    }

    protected processRolesDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    rolesGet(  cancelToken?: CancelToken | undefined): Promise<GetRoleResponse[]> {
        let url_ = this.baseUrl + "/api/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRolesGet(_response);
        });
    }

    protected processRolesGet(response: AxiosResponse): Promise<GetRoleResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetRoleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetRoleResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleResponse[]>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    claims(id: string , cancelToken?: CancelToken | undefined): Promise<GetClaimResponse[]> {
        let url_ = this.baseUrl + "/api/Roles/{id}/Claims";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClaims(_response);
        });
    }

    protected processClaims(response: AxiosResponse): Promise<GetClaimResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetClaimResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetClaimResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetClaimResponse[]>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    roleClaimAssociation(body?: RoleClaimAssociationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<Response> {
        let url_ = this.baseUrl + "/api/Roles/RoleClaimAssociation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleClaimAssociation(_response);
        });
    }

    protected processRoleClaimAssociation(response: AxiosResponse): Promise<Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Response.fromJS(resultData200);
            return Promise.resolve<Response>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Response>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    roleGetById(id: string , cancelToken?: CancelToken | undefined): Promise<GetRoleResponse> {
        let url_ = this.baseUrl + "/api/Roles/RoleGetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetById(_response);
        });
    }

    protected processRoleGetById(response: AxiosResponse): Promise<GetRoleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRoleResponse.fromJS(resultData200);
            return Promise.resolve<GetRoleResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRoleResponse>(null as any);
    }
}

export class SectionsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNamePOST, user:exists)
     * @param body (optional) 
     * @return Success
     */
    sectionsPost(body?: CreateSectionRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Sections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSectionsPost(_response);
        });
    }

    protected processSectionsPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNamePUT, user:exists)
     * @param body (optional) 
     * @return Success
     */
    sectionsPut(body?: UpdateSectionRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Sections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSectionsPut(_response);
        });
    }

    protected processSectionsPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNameDELETE, user:exists)
     * @param body (optional) 
     * @return Success
     */
    sectionsDelete(body?: DeleteSectionRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Sections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSectionsDelete(_response);
        });
    }

    protected processSectionsDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    sectionsGet(id: string , cancelToken?: CancelToken | undefined): Promise<GetSectionResponse> {
        let url_ = this.baseUrl + "/api/Sections/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSectionsGet(_response);
        });
    }

    protected processSectionsGet(response: AxiosResponse): Promise<GetSectionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSectionResponse.fromJS(resultData200);
            return Promise.resolve<GetSectionResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSectionResponse>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    processes(id: string , cancelToken?: CancelToken | undefined): Promise<GetAllSectionProcessesResponse> {
        let url_ = this.baseUrl + "/api/Sections/{id}/Processes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcesses(_response);
        });
    }

    protected processProcesses(response: AxiosResponse): Promise<GetAllSectionProcessesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllSectionProcessesResponse.fromJS(resultData200);
            return Promise.resolve<GetAllSectionProcessesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllSectionProcessesResponse>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    sectionTranslations(id: string , cancelToken?: CancelToken | undefined): Promise<GetSectionTranslationResponse[]> {
        let url_ = this.baseUrl + "/api/Sections/{id}/SectionTranslations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSectionTranslations(_response);
        });
    }

    protected processSectionTranslations(response: AxiosResponse): Promise<GetSectionTranslationResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSectionTranslationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetSectionTranslationResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSectionTranslationResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    sectionDefaultTranslation(sectionId: string , cancelToken?: CancelToken | undefined): Promise<GetSectionTranslationResponse[]> {
        let url_ = this.baseUrl + "/api/Sections/{sectionId}/SectionDefaultTranslation";
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSectionDefaultTranslation(_response);
        });
    }

    protected processSectionDefaultTranslation(response: AxiosResponse): Promise<GetSectionTranslationResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSectionTranslationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetSectionTranslationResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSectionTranslationResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNameDELETE, user:exists)
     * @param body (optional) 
     * @return Success
     */
    deleteSectionTranslation(body?: DeleteSectionTranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Sections/DeleteSectionTranslation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSectionTranslation(_response);
        });
    }

    protected processDeleteSectionTranslation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    getAllOrganizationSections(  cancelToken?: CancelToken | undefined): Promise<GetSectionResponse[]> {
        let url_ = this.baseUrl + "/api/Sections/GetAllOrganizationSections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOrganizationSections(_response);
        });
    }

    protected processGetAllOrganizationSections(response: AxiosResponse): Promise<GetSectionResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSectionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetSectionResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSectionResponse[]>(null as any);
    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    sectionsProcesses(  cancelToken?: CancelToken | undefined): Promise<GetAllSectionProcessesResponse[]> {
        let url_ = this.baseUrl + "/api/Sections/SectionsProcesses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSectionsProcesses(_response);
        });
    }

    protected processSectionsProcesses(response: AxiosResponse): Promise<GetAllSectionProcessesResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAllSectionProcessesResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetAllSectionProcessesResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllSectionProcessesResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    sectionTranslation(id: string , cancelToken?: CancelToken | undefined): Promise<GetSectionTranslationResponse> {
        let url_ = this.baseUrl + "/api/Sections/SectionTranslation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSectionTranslation(_response);
        });
    }

    protected processSectionTranslation(response: AxiosResponse): Promise<GetSectionTranslationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSectionTranslationResponse.fromJS(resultData200);
            return Promise.resolve<GetSectionTranslationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSectionTranslationResponse>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNamePOST, user:exists)
     * @param body (optional) 
     * @return Success
     */
    translateSection(body?: TranslateSectionRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Sections/TranslateSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslateSection(_response);
        });
    }

    protected processTranslateSection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNamePOST, user:exists)
     * @param body (optional) 
     * @return Success
     */
    translationsPost(body?: CreateSectionTranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Sections/Translations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslationsPost(_response);
        });
    }

    protected processTranslationsPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceSection;LegalTech.ActionNamePUT, user:exists)
     * @param body (optional) 
     * @return Success
     */
    translationsPut(body?: UpdateSectionTranslationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Sections/Translations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslationsPut(_response);
        });
    }

    protected processTranslationsPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SurveyClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: user:exists)
     * @param body (optional) 
     * @return Success
     */
    state(body?: UpdateProgressForExternalQuestionnaire | undefined , cancelToken?: CancelToken | undefined): Promise<IActionResult> {
        let url_ = this.baseUrl + "/api/Survey/State";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processState(_response);
        });
    }

    protected processState(response: AxiosResponse): Promise<IActionResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IActionResult.fromJS(resultData200);
            return Promise.resolve<IActionResult>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IActionResult>(null as any);
    }
}

export class SystemsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: user:exists)
     * @param body (optional) 
     * @return Created
     */
    systemsPost(body?: Systems | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Systems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemsPost(_response);
        });
    }

    protected processSystemsPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    systemsGet(  cancelToken?: CancelToken | undefined): Promise<GetSystemsResponse[]> {
        let url_ = this.baseUrl + "/api/Systems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemsGet(_response);
        });
    }

    protected processSystemsGet(response: AxiosResponse): Promise<GetSystemsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSystemsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetSystemsResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * (Auth policies: user:exists)
     * @param body (optional) 
     * @return Success
     */
    systemsPut(id: string, body?: Systems | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Systems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemsPut(_response);
        });
    }

    protected processSystemsPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);

        }
    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    systemsGetById(id: string , cancelToken?: CancelToken | undefined): Promise<GetSystemsResponse> {
        let url_ = this.baseUrl + "/api/Systems/SystemsGetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSystemsGetById(_response);
        });
    }

    protected processSystemsGetById(response: AxiosResponse): Promise<GetSystemsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSystemsResponse.fromJS(resultData200);
            return Promise.resolve<GetSystemsResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else {
            const _responseText = response.data;
            let resultdefault: any = null;
            let resultDatadefault  = _responseText;
            resultdefault = ProblemDetails.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);

        }
    }
}

export class TasksClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNamePOST, user:exists)
     * @param body (optional) 
     * @return Success
     */
    tasksPost(body?: CreateTasksRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTasksPost(_response);
        });
    }

    protected processTasksPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNameDELETE, user:exists)
     * @param body (optional) 
     * @return Success
     */
    tasksDelete(body?: DeleteTasksRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTasksDelete(_response);
        });
    }

    protected processTasksDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    tasksGet(id: string , cancelToken?: CancelToken | undefined): Promise<GetTasksResponse> {
        let url_ = this.baseUrl + "/api/Tasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTasksGet(_response);
        });
    }

    protected processTasksGet(response: AxiosResponse): Promise<GetTasksResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTasksResponse.fromJS(resultData200);
            return Promise.resolve<GetTasksResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTasksResponse>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNameGET, user:exists)
     * @param year (optional) 
     * @return Success
     */
    annualTasks(year?: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetTasksResponse[]> {
        let url_ = this.baseUrl + "/api/Tasks/AnnualTasks?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnnualTasks(_response);
        });
    }

    protected processAnnualTasks(response: AxiosResponse): Promise<GetTasksResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTasksResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetTasksResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTasksResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    getAnnualCycleOfWorkTasks(  cancelToken?: CancelToken | undefined): Promise<GetTasksResponse[]> {
        let url_ = this.baseUrl + "/api/Tasks/GetAnnualCycleOfWorkTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnnualCycleOfWorkTasks(_response);
        });
    }

    protected processGetAnnualCycleOfWorkTasks(response: AxiosResponse): Promise<GetTasksResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTasksResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetTasksResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTasksResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNameGET, user:exists)
     * @param pageNo (optional) 
     * @param limit (optional) 
     * @param textFilter (optional) 
     * @return Success
     */
    organizationTasks(pageNo?: number | undefined, limit?: number | undefined, textFilter?: string | undefined , cancelToken?: CancelToken | undefined): Promise<GetTasksResponsePagedList> {
        let url_ = this.baseUrl + "/api/Tasks/OrganizationTasks?";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (textFilter === null)
            throw new Error("The parameter 'textFilter' cannot be null.");
        else if (textFilter !== undefined)
            url_ += "textFilter=" + encodeURIComponent("" + textFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationTasks(_response);
        });
    }

    protected processOrganizationTasks(response: AxiosResponse): Promise<GetTasksResponsePagedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTasksResponsePagedList.fromJS(resultData200);
            return Promise.resolve<GetTasksResponsePagedList>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTasksResponsePagedList>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNamePUT, user:exists)
     * @param body (optional) 
     * @return Success
     */
    updateTask(body?: UpdateTasksRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Tasks/UpdateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTask(_response);
        });
    }

    protected processUpdateTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNamePUT, user:exists)
     * @param body (optional) 
     * @return Success
     */
    updateTaskStatus(body?: UpdateTasksStatusRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Tasks/UpdateTaskStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTaskStatus(_response);
        });
    }

    protected processUpdateTaskStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TasksVClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNameGET)
     * @return Success
     */
    tasksV(id: string , cancelToken?: CancelToken | undefined): Promise<GetTasksResponseV2> {
        let url_ = this.baseUrl + "/api/TasksV/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTasksV(_response);
        });
    }

    protected processTasksV(response: AxiosResponse): Promise<GetTasksResponseV2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTasksResponseV2.fromJS(resultData200);
            return Promise.resolve<GetTasksResponseV2>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTasksResponseV2>(null as any);
    }

    /**
     * (Auth)
     * @param body (optional) 
     * @return Success
     */
    createTaskVersion2(body?: CreateTasksRequestV2 | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TasksV/CreateTaskVersion2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTaskVersion2(_response);
        });
    }

    protected processCreateTaskVersion2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceTask;LegalTech.ActionNamePUT)
     * @param body (optional) 
     * @return Success
     */
    updateTask(body?: UpdateTasksRequestV2 | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TasksV/UpdateTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTask(_response);
        });
    }

    protected processUpdateTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TeamsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    teamsPost(body?: CreateTeamRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeamsPost(_response);
        });
    }

    protected processTeamsPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    teamsPut(body?: UpdateTeamRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeamsPut(_response);
        });
    }

    protected processTeamsPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    teamsDelete(body?: DeleteTeamRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeamsDelete(_response);
        });
    }

    protected processTeamsDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    partnerTeamUsers(organizationId: string, teamId: string , cancelToken?: CancelToken | undefined): Promise<GetTeamResponse> {
        let url_ = this.baseUrl + "/api/Teams/{organizationId}/{teamId}/PartnerTeamUsers";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerTeamUsers(_response);
        });
    }

    protected processPartnerTeamUsers(response: AxiosResponse): Promise<GetTeamResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTeamResponse.fromJS(resultData200);
            return Promise.resolve<GetTeamResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTeamResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    teamsGet(organizationId: string , cancelToken?: CancelToken | undefined): Promise<GetTeamResponse[]> {
        let url_ = this.baseUrl + "/api/Teams/{organizationId}/Teams";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeamsGet(_response);
        });
    }

    protected processTeamsGet(response: AxiosResponse): Promise<GetTeamResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTeamResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetTeamResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTeamResponse[]>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    teamUsers(teamId: string , cancelToken?: CancelToken | undefined): Promise<GetTeamResponse> {
        let url_ = this.baseUrl + "/api/Teams/{teamId}/TeamUsers";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeamUsers(_response);
        });
    }

    protected processTeamUsers(response: AxiosResponse): Promise<GetTeamResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTeamResponse.fromJS(resultData200);
            return Promise.resolve<GetTeamResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTeamResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @return Success
     */
    teamsGetById(id: string , cancelToken?: CancelToken | undefined): Promise<GetTeamResponse> {
        let url_ = this.baseUrl + "/api/Teams/TeamsGetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeamsGetById(_response);
        });
    }

    protected processTeamsGetById(response: AxiosResponse): Promise<GetTeamResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTeamResponse.fromJS(resultData200);
            return Promise.resolve<GetTeamResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTeamResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    teamUserAssociationPost(body?: TeamUserAssociationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Teams/TeamUserAssociation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeamUserAssociationPost(_response);
        });
    }

    protected processTeamUserAssociationPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove, user:exists)
     * @param body (optional) 
     * @return Success
     */
    teamUserAssociationDelete(body?: TeamUserAssociationRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Teams/TeamUserAssociation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTeamUserAssociationDelete(_response);
        });
    }

    protected processTeamUserAssociationDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsersClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNamePOST, user:exists)
     * @param roleIds (optional) 
     * @param roleIdsJson (optional) 
     * @param name (optional) 
     * @param organizationId (optional) 
     * @param phone (optional) 
     * @param email (optional) 
     * @param file (optional) 
     * @param customFieldValues (optional) 
     * @return Success
     */
    usersPost(roleIds?: string[] | undefined, roleIdsJson?: string | undefined, name?: string | undefined, organizationId?: string | undefined, phone?: string | undefined, email?: string | undefined, file?: FileParameter | undefined, customFieldValues?: CustomFieldValues[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (roleIds === null || roleIds === undefined)
            throw new Error("The parameter 'roleIds' cannot be null.");
        else
            roleIds.forEach(item_ => content_.append("RoleIds", item_.toString()));
        if (roleIdsJson === null || roleIdsJson === undefined)
            throw new Error("The parameter 'roleIdsJson' cannot be null.");
        else
            content_.append("RoleIdsJson", roleIdsJson.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (organizationId === null || organizationId === undefined)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else
            content_.append("OrganizationId", organizationId.toString());
        if (phone === null || phone === undefined)
            throw new Error("The parameter 'phone' cannot be null.");
        else
            content_.append("Phone", phone.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("Email", email.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (customFieldValues === null || customFieldValues === undefined)
            throw new Error("The parameter 'customFieldValues' cannot be null.");
        else
            customFieldValues.forEach(item_ => content_.append("CustomFieldValues", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersPost(_response);
        });
    }

    protected processUsersPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNamePUT, user:exists)
     * @param id (optional) 
     * @param roleIds (optional) 
     * @param roleIdsJson (optional) 
     * @param name (optional) 
     * @param organizationId (optional) 
     * @param phone (optional) 
     * @param email (optional) 
     * @param file (optional) 
     * @param customFieldValues (optional) 
     * @return Success
     */
    usersPut(id?: string | undefined, roleIds?: string[] | undefined, roleIdsJson?: string | undefined, name?: string | undefined, organizationId?: string | undefined, phone?: string | undefined, email?: string | undefined, file?: FileParameter | undefined, customFieldValues?: CustomFieldValues[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (roleIds === null || roleIds === undefined)
            throw new Error("The parameter 'roleIds' cannot be null.");
        else
            roleIds.forEach(item_ => content_.append("RoleIds", item_.toString()));
        if (roleIdsJson === null || roleIdsJson === undefined)
            throw new Error("The parameter 'roleIdsJson' cannot be null.");
        else
            content_.append("RoleIdsJson", roleIdsJson.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (organizationId === null || organizationId === undefined)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else
            content_.append("OrganizationId", organizationId.toString());
        if (phone === null || phone === undefined)
            throw new Error("The parameter 'phone' cannot be null.");
        else
            content_.append("Phone", phone.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("Email", email.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (customFieldValues === null || customFieldValues === undefined)
            throw new Error("The parameter 'customFieldValues' cannot be null.");
        else
            customFieldValues.forEach(item_ => content_.append("CustomFieldValues", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersPut(_response);
        });
    }

    protected processUsersPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameDELETE, user:exists)
     * @param body (optional) 
     * @return Success
     */
    usersDelete(body?: DeleteUserRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersDelete(_response);
        });
    }

    protected processUsersDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: IsDeveloper, LegalTech.ResourceUser;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    usersGet(  cancelToken?: CancelToken | undefined): Promise<GetUserResponse[]> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersGet(_response);
        });
    }

    protected processUsersGet(response: AxiosResponse): Promise<GetUserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetUserResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    companyAllUsers(id: string , cancelToken?: CancelToken | undefined): Promise<GetUserResponse[]> {
        let url_ = this.baseUrl + "/api/Users/{id}/CompanyAllUsers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompanyAllUsers(_response);
        });
    }

    protected processCompanyAllUsers(response: AxiosResponse): Promise<GetUserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetUserResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    partnerAllUsers(id: string , cancelToken?: CancelToken | undefined): Promise<GetUserResponse[]> {
        let url_ = this.baseUrl + "/api/Users/{id}/PartnerAllUsers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerAllUsers(_response);
        });
    }

    protected processPartnerAllUsers(response: AxiosResponse): Promise<GetUserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetUserResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    partnerAllUsersWithType(id: string , cancelToken?: CancelToken | undefined): Promise<GetUserResponse[]> {
        let url_ = this.baseUrl + "/api/Users/{id}/PartnerAllUsersWithType";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartnerAllUsersWithType(_response);
        });
    }

    protected processPartnerAllUsersWithType(response: AxiosResponse): Promise<GetUserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetUserResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    userDetailGetById(id: string , cancelToken?: CancelToken | undefined): Promise<GetUserDetailResponse> {
        let url_ = this.baseUrl + "/api/Users/{id}/UserDetailGetById";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserDetailGetById(_response);
        });
    }

    protected processUserDetailGetById(response: AxiosResponse): Promise<GetUserDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetUserDetailResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserDetailResponse>(null as any);
    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    accountRepresentativeList(organizationId: string , cancelToken?: CancelToken | undefined): Promise<GetUserResponse[]> {
        let url_ = this.baseUrl + "/api/Users/{organizationId}/AccountRepresentativeList";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccountRepresentativeList(_response);
        });
    }

    protected processAccountRepresentativeList(response: AxiosResponse): Promise<GetUserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetUserResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    userListGetByOrgId(organizationId: string , cancelToken?: CancelToken | undefined): Promise<GetUserResponse[]> {
        let url_ = this.baseUrl + "/api/Users/{organizationId}/UserListGetByOrgId";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserListGetByOrgId(_response);
        });
    }

    protected processUserListGetByOrgId(response: AxiosResponse): Promise<GetUserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetUserResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    userDetail(userId: string, partnerId: string , cancelToken?: CancelToken | undefined): Promise<GetUserDetailResponse> {
        let url_ = this.baseUrl + "/api/Users/{userId}/{partnerId}/UserDetail";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserDetail(_response);
        });
    }

    protected processUserDetail(response: AxiosResponse): Promise<GetUserDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetUserDetailResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserDetailResponse>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameDELETE, user:exists)
     * @param body (optional) 
     * @return Success
     */
    organizationUser(body?: DeleteOrganizationUserRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/OrganizationUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganizationUser(_response);
        });
    }

    protected processOrganizationUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNamePUT, user:exists)
     * @param id (optional) 
     * @param roleIds (optional) 
     * @param roleIdsJson (optional) 
     * @param name (optional) 
     * @param organizationId (optional) 
     * @param phone (optional) 
     * @param email (optional) 
     * @param file (optional) 
     * @param customFieldValues (optional) 
     * @return Success
     */
    updatePlatformUser(id?: string | undefined, roleIds?: string[] | undefined, roleIdsJson?: string | undefined, name?: string | undefined, organizationId?: string | undefined, phone?: string | undefined, email?: string | undefined, file?: FileParameter | undefined, customFieldValues?: CustomFieldValues[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/UpdatePlatformUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (roleIds === null || roleIds === undefined)
            throw new Error("The parameter 'roleIds' cannot be null.");
        else
            roleIds.forEach(item_ => content_.append("RoleIds", item_.toString()));
        if (roleIdsJson === null || roleIdsJson === undefined)
            throw new Error("The parameter 'roleIdsJson' cannot be null.");
        else
            content_.append("RoleIdsJson", roleIdsJson.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("Name", name.toString());
        if (organizationId === null || organizationId === undefined)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else
            content_.append("OrganizationId", organizationId.toString());
        if (phone === null || phone === undefined)
            throw new Error("The parameter 'phone' cannot be null.");
        else
            content_.append("Phone", phone.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("Email", email.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (customFieldValues === null || customFieldValues === undefined)
            throw new Error("The parameter 'customFieldValues' cannot be null.");
        else
            customFieldValues.forEach(item_ => content_.append("CustomFieldValues", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlatformUser(_response);
        });
    }

    protected processUpdatePlatformUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: user:exists)
     * @param body (optional) 
     * @return Success
     */
    updateUserSetting(body?: UpdateUserSettingRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/UpdateUserSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserSetting(_response);
        });
    }

    protected processUpdateUserSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    userList(  cancelToken?: CancelToken | undefined): Promise<GetUserResponse[]> {
        let url_ = this.baseUrl + "/api/Users/UserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserList(_response);
        });
    }

    protected processUserList(response: AxiosResponse): Promise<GetUserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GetUserResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserResponse[]>(null as any);
    }

    /**
     * (Auth policies: LegalTech.ResourceUser;LegalTech.ActionNameGET, user:exists)
     * @return Success
     */
    usersGetById(id: string , cancelToken?: CancelToken | undefined): Promise<GetUserResponse> {
        let url_ = this.baseUrl + "/api/Users/UsersGetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersGetById(_response);
        });
    }

    protected processUsersGetById(response: AxiosResponse): Promise<GetUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserResponse.fromJS(resultData200);
            return Promise.resolve<GetUserResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserResponse>(null as any);
    }
}

export class WizardsClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: user:exists)
     * @return Success
     */
    pagesList(id: string , cancelToken?: CancelToken | undefined): Promise<GetPageListResponse> {
        let url_ = this.baseUrl + "/api/Wizards/{id}/PagesList";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPagesList(_response);
        });
    }

    protected processPagesList(response: AxiosResponse): Promise<GetPageListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPageListResponse.fromJS(resultData200);
            return Promise.resolve<GetPageListResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPageListResponse>(null as any);
    }

    /**
     * (Auth policies: user:exists)
     * @param body (optional) 
     * @return Success
     */
    duplicateWizard(body?: DuplicateWizardRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Wizards/DuplicateWizard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDuplicateWizard(_response);
        });
    }

    protected processDuplicateWizard(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AccountRepresentative implements IAccountRepresentative {
    value!: string | undefined;
    label!: string | undefined;

    constructor(data?: IAccountRepresentative) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): AccountRepresentative {
        data = typeof data === 'object' ? data : {};
        let result = new AccountRepresentative();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IAccountRepresentative {
    value: string | undefined;
    label: string | undefined;
}

export class AnswerOptionSetValues implements IAnswerOptionSetValues {
    id!: string;
    value!: string | undefined;
    text!: string | undefined;

    constructor(data?: IAnswerOptionSetValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AnswerOptionSetValues {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerOptionSetValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["text"] = this.text;
        return data;
    }
}

export interface IAnswerOptionSetValues {
    id: string;
    value: string | undefined;
    text: string | undefined;
}

export class Answers implements IAnswers {
    questionId!: string;
    answer!: string | undefined;
    answerDisplayTypeCode!: number;
    answerTypeCode!: number;
    dateSelected!: dayjs.Dayjs | undefined;
    answerOptionsSetValues!: string[] | undefined;

    constructor(data?: IAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answer = _data["answer"];
            this.answerDisplayTypeCode = _data["answerDisplayTypeCode"];
            this.answerTypeCode = _data["answerTypeCode"];
            this.dateSelected = _data["dateSelected"] ? dayjs(_data["dateSelected"].toString()) : <any>undefined;
            if (Array.isArray(_data["answerOptionsSetValues"])) {
                this.answerOptionsSetValues = [] as any;
                for (let item of _data["answerOptionsSetValues"])
                    this.answerOptionsSetValues!.push(item);
            }
        }
    }

    static fromJS(data: any): Answers {
        data = typeof data === 'object' ? data : {};
        let result = new Answers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answer"] = this.answer;
        data["answerDisplayTypeCode"] = this.answerDisplayTypeCode;
        data["answerTypeCode"] = this.answerTypeCode;
        data["dateSelected"] = this.dateSelected ? this.dateSelected.toISOString() : <any>undefined;
        if (Array.isArray(this.answerOptionsSetValues)) {
            data["answerOptionsSetValues"] = [];
            for (let item of this.answerOptionsSetValues)
                data["answerOptionsSetValues"].push(item);
        }
        return data;
    }
}

export interface IAnswers {
    questionId: string;
    answer: string | undefined;
    answerDisplayTypeCode: number;
    answerTypeCode: number;
    dateSelected: dayjs.Dayjs | undefined;
    answerOptionsSetValues: string[] | undefined;
}

export class ApprovalStepDetail implements IApprovalStepDetail {
    name!: string | undefined;
    description!: string | undefined;
    commentOnApprove!: boolean;
    commentOnReject!: boolean;
    autoApproveForTriggerer!: boolean;

    constructor(data?: IApprovalStepDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.commentOnApprove = _data["commentOnApprove"];
            this.commentOnReject = _data["commentOnReject"];
            this.autoApproveForTriggerer = _data["autoApproveForTriggerer"];
        }
    }

    static fromJS(data: any): ApprovalStepDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalStepDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["commentOnApprove"] = this.commentOnApprove;
        data["commentOnReject"] = this.commentOnReject;
        data["autoApproveForTriggerer"] = this.autoApproveForTriggerer;
        return data;
    }
}

export interface IApprovalStepDetail {
    name: string | undefined;
    description: string | undefined;
    commentOnApprove: boolean;
    commentOnReject: boolean;
    autoApproveForTriggerer: boolean;
}

export class ApprovalsProgress implements IApprovalsProgress {
    userName!: string | undefined;
    userId!: string;
    approvalFlowState!: number;
    approvalFlowOrder!: number;

    constructor(data?: IApprovalsProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userId = _data["userId"];
            this.approvalFlowState = _data["approvalFlowState"];
            this.approvalFlowOrder = _data["approvalFlowOrder"];
        }
    }

    static fromJS(data: any): ApprovalsProgress {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalsProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userId"] = this.userId;
        data["approvalFlowState"] = this.approvalFlowState;
        data["approvalFlowOrder"] = this.approvalFlowOrder;
        return data;
    }
}

export interface IApprovalsProgress {
    userName: string | undefined;
    userId: string;
    approvalFlowState: number;
    approvalFlowOrder: number;
}

export class ApproveTemplateAnswersRequest implements IApproveTemplateAnswersRequest {
    entities!: string[] | undefined;

    constructor(data?: IApproveTemplateAnswersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(item);
            }
        }
    }

    static fromJS(data: any): ApproveTemplateAnswersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveTemplateAnswersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item);
        }
        return data;
    }
}

export interface IApproveTemplateAnswersRequest {
    entities: string[] | undefined;
}

export class ChangeUserDefaultLanguageRequest implements IChangeUserDefaultLanguageRequest {
    currentDefaultUserId!: string;
    currentDefaultOrganizationId!: string;
    selectedLanguageForDefault!: string | undefined;

    constructor(data?: IChangeUserDefaultLanguageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentDefaultUserId = _data["currentDefaultUserId"];
            this.currentDefaultOrganizationId = _data["currentDefaultOrganizationId"];
            this.selectedLanguageForDefault = _data["selectedLanguageForDefault"];
        }
    }

    static fromJS(data: any): ChangeUserDefaultLanguageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserDefaultLanguageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentDefaultUserId"] = this.currentDefaultUserId;
        data["currentDefaultOrganizationId"] = this.currentDefaultOrganizationId;
        data["selectedLanguageForDefault"] = this.selectedLanguageForDefault;
        return data;
    }
}

export interface IChangeUserDefaultLanguageRequest {
    currentDefaultUserId: string;
    currentDefaultOrganizationId: string;
    selectedLanguageForDefault: string | undefined;
}

export class ChangeUserDefaultOrganizationRequest implements IChangeUserDefaultOrganizationRequest {
    currentDefaultUserId!: string;
    currentDefaultOrganizationId!: string;
    selectedForDefaultOrganizationId!: string;
    selectedForDefaultUserId!: string;

    constructor(data?: IChangeUserDefaultOrganizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentDefaultUserId = _data["currentDefaultUserId"];
            this.currentDefaultOrganizationId = _data["currentDefaultOrganizationId"];
            this.selectedForDefaultOrganizationId = _data["selectedForDefaultOrganizationId"];
            this.selectedForDefaultUserId = _data["selectedForDefaultUserId"];
        }
    }

    static fromJS(data: any): ChangeUserDefaultOrganizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserDefaultOrganizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentDefaultUserId"] = this.currentDefaultUserId;
        data["currentDefaultOrganizationId"] = this.currentDefaultOrganizationId;
        data["selectedForDefaultOrganizationId"] = this.selectedForDefaultOrganizationId;
        data["selectedForDefaultUserId"] = this.selectedForDefaultUserId;
        return data;
    }
}

export interface IChangeUserDefaultOrganizationRequest {
    currentDefaultUserId: string;
    currentDefaultOrganizationId: string;
    selectedForDefaultOrganizationId: string;
    selectedForDefaultUserId: string;
}

export class ChangeUserFavoriteOrganizationRequest implements IChangeUserFavoriteOrganizationRequest {
    currentDefaultUserId!: string;
    currentDefaultOrganizationId!: string;
    isFavorite!: boolean;

    constructor(data?: IChangeUserFavoriteOrganizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentDefaultUserId = _data["currentDefaultUserId"];
            this.currentDefaultOrganizationId = _data["currentDefaultOrganizationId"];
            this.isFavorite = _data["isFavorite"];
        }
    }

    static fromJS(data: any): ChangeUserFavoriteOrganizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserFavoriteOrganizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentDefaultUserId"] = this.currentDefaultUserId;
        data["currentDefaultOrganizationId"] = this.currentDefaultOrganizationId;
        data["isFavorite"] = this.isFavorite;
        return data;
    }
}

export interface IChangeUserFavoriteOrganizationRequest {
    currentDefaultUserId: string;
    currentDefaultOrganizationId: string;
    isFavorite: boolean;
}

export class ChangeUserFavoritePartnerRequest implements IChangeUserFavoritePartnerRequest {
    userId!: string;
    organizationId!: string;
    isPartnerFavourite!: boolean;

    constructor(data?: IChangeUserFavoritePartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.isPartnerFavourite = _data["isPartnerFavourite"];
        }
    }

    static fromJS(data: any): ChangeUserFavoritePartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserFavoritePartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["isPartnerFavourite"] = this.isPartnerFavourite;
        return data;
    }
}

export interface IChangeUserFavoritePartnerRequest {
    userId: string;
    organizationId: string;
    isPartnerFavourite: boolean;
}

export class Column implements IColumn {
    name!: string | undefined;
    cellType!: string | undefined;
    title!: string | undefined;
    minWidth!: string | undefined;
    isRequired!: boolean;
    inputType!: string | undefined;
    readOnly!: boolean;
    rows!: string | undefined;
    rateValues!: AnswerOptionSetValues[] | undefined;
    readonly expression!: string | undefined;
    readonly displayStyle!: string | undefined;
    readonly width!: string | undefined;
    readonly optionsByUrl!: string | undefined;
    readonly choices!: AnswerOptionSetValues[] | undefined;
    readonly defaultValue!: string | undefined;
    readonly maximumFractionDigits!: number;
    readonly minimumFractionDigits!: number;

    constructor(data?: IColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cellType = _data["cellType"];
            this.title = _data["title"];
            this.minWidth = _data["minWidth"];
            this.isRequired = _data["isRequired"];
            this.inputType = _data["inputType"];
            this.readOnly = _data["readOnly"];
            this.rows = _data["rows"];
            if (Array.isArray(_data["rateValues"])) {
                this.rateValues = [] as any;
                for (let item of _data["rateValues"])
                    this.rateValues!.push(AnswerOptionSetValues.fromJS(item));
            }
            (<any>this).expression = _data["expression"];
            (<any>this).displayStyle = _data["displayStyle"];
            (<any>this).width = _data["width"];
            (<any>this).optionsByUrl = _data["optionsByUrl"];
            if (Array.isArray(_data["choices"])) {
                (<any>this).choices = [] as any;
                for (let item of _data["choices"])
                    (<any>this).choices!.push(AnswerOptionSetValues.fromJS(item));
            }
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).maximumFractionDigits = _data["maximumFractionDigits"];
            (<any>this).minimumFractionDigits = _data["minimumFractionDigits"];
        }
    }

    static fromJS(data: any): Column {
        data = typeof data === 'object' ? data : {};
        let result = new Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cellType"] = this.cellType;
        data["title"] = this.title;
        data["minWidth"] = this.minWidth;
        data["isRequired"] = this.isRequired;
        data["inputType"] = this.inputType;
        data["readOnly"] = this.readOnly;
        data["rows"] = this.rows;
        if (Array.isArray(this.rateValues)) {
            data["rateValues"] = [];
            for (let item of this.rateValues)
                data["rateValues"].push(item.toJSON());
        }
        data["expression"] = this.expression;
        data["displayStyle"] = this.displayStyle;
        data["width"] = this.width;
        data["optionsByUrl"] = this.optionsByUrl;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        data["defaultValue"] = this.defaultValue;
        data["maximumFractionDigits"] = this.maximumFractionDigits;
        data["minimumFractionDigits"] = this.minimumFractionDigits;
        return data;
    }
}

export interface IColumn {
    name: string | undefined;
    cellType: string | undefined;
    title: string | undefined;
    minWidth: string | undefined;
    isRequired: boolean;
    inputType: string | undefined;
    readOnly: boolean;
    rows: string | undefined;
    rateValues: AnswerOptionSetValues[] | undefined;
    expression: string | undefined;
    displayStyle: string | undefined;
    width: string | undefined;
    optionsByUrl: string | undefined;
    choices: AnswerOptionSetValues[] | undefined;
    defaultValue: string | undefined;
    maximumFractionDigits: number;
    minimumFractionDigits: number;
}

export class CreateCompanyRequest implements ICreateCompanyRequest {
    systemIds!: string[] | undefined;
    userName!: string | undefined;
    userEmail!: string | undefined;
    userPhone!: string | undefined;
    accountRepresentatives!: string[] | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: ICreateCompanyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["systemIds"])) {
                this.systemIds = [] as any;
                for (let item of _data["systemIds"])
                    this.systemIds!.push(item);
            }
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.userPhone = _data["userPhone"];
            if (Array.isArray(_data["accountRepresentatives"])) {
                this.accountRepresentatives = [] as any;
                for (let item of _data["accountRepresentatives"])
                    this.accountRepresentatives!.push(item);
            }
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): CreateCompanyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemIds)) {
            data["systemIds"] = [];
            for (let item of this.systemIds)
                data["systemIds"].push(item);
        }
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["userPhone"] = this.userPhone;
        if (Array.isArray(this.accountRepresentatives)) {
            data["accountRepresentatives"] = [];
            for (let item of this.accountRepresentatives)
                data["accountRepresentatives"].push(item);
        }
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface ICreateCompanyRequest {
    systemIds: string[] | undefined;
    userName: string | undefined;
    userEmail: string | undefined;
    userPhone: string | undefined;
    accountRepresentatives: string[] | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class CreateCustomEntityValueRequest implements ICreateCustomEntityValueRequest {
    parentId!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    regardingObjectTypeId!: string;
    userId!: string | undefined;
    wizardId!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: ICreateCustomEntityValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.userId = _data["userId"];
            this.wizardId = _data["wizardId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCustomEntityValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomEntityValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["userId"] = this.userId;
        data["wizardId"] = this.wizardId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateCustomEntityValueRequest {
    parentId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    regardingObjectTypeId: string;
    userId: string | undefined;
    wizardId: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class CreatePartnerRequest implements ICreatePartnerRequest {
    systemIds!: string[];
    userName!: string | undefined;
    userEmail!: string | undefined;
    userPhone!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: ICreatePartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.systemIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["systemIds"])) {
                this.systemIds = [] as any;
                for (let item of _data["systemIds"])
                    this.systemIds!.push(item);
            }
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.userPhone = _data["userPhone"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): CreatePartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemIds)) {
            data["systemIds"] = [];
            for (let item of this.systemIds)
                data["systemIds"].push(item);
        }
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["userPhone"] = this.userPhone;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface ICreatePartnerRequest {
    systemIds: string[];
    userName: string | undefined;
    userEmail: string | undefined;
    userPhone: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class CreateProjectRequest implements ICreateProjectRequest {
    systemIds!: string[] | undefined;
    userName!: string | undefined;
    userEmail!: string | undefined;
    userPhone!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: ICreateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["systemIds"])) {
                this.systemIds = [] as any;
                for (let item of _data["systemIds"])
                    this.systemIds!.push(item);
            }
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.userPhone = _data["userPhone"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): CreateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemIds)) {
            data["systemIds"] = [];
            for (let item of this.systemIds)
                data["systemIds"].push(item);
        }
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["userPhone"] = this.userPhone;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface ICreateProjectRequest {
    systemIds: string[] | undefined;
    userName: string | undefined;
    userEmail: string | undefined;
    userPhone: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class CreateQuestionAnswerRequest implements ICreateQuestionAnswerRequest {
    language!: string | undefined;
    regardingObjectTypeId!: string;
    regardingObjectId!: string;
    answers!: Answers[] | undefined;
    validated!: boolean;
    triggerFlow!: boolean;

    constructor(data?: ICreateQuestionAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.regardingObjectId = _data["regardingObjectId"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(Answers.fromJS(item));
            }
            this.validated = _data["validated"];
            this.triggerFlow = _data["triggerFlow"];
        }
    }

    static fromJS(data: any): CreateQuestionAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["regardingObjectId"] = this.regardingObjectId;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["validated"] = this.validated;
        data["triggerFlow"] = this.triggerFlow;
        return data;
    }
}

export interface ICreateQuestionAnswerRequest {
    language: string | undefined;
    regardingObjectTypeId: string;
    regardingObjectId: string;
    answers: Answers[] | undefined;
    validated: boolean;
    triggerFlow: boolean;
}

export class CreateQuestionRequest implements ICreateQuestionRequest {
    title!: string | undefined;
    descriptionShort!: string | undefined;
    descriptionLong!: string | undefined;
    language!: string | undefined;
    referenceDisplayText!: string | undefined;
    reference!: string | undefined;
    name!: string | undefined;
    order!: number | undefined;
    condition!: string | undefined;
    answerOptionSetId!: string;
    panelId!: string;
    expression!: string | undefined;
    defaultValue!: string | undefined;
    readOnly!: boolean;
    isRequired!: boolean;
    regardingObjectTypeId!: string | undefined;
    moduleConditions!: string | undefined;
    moduleConditionsV1!: string | undefined;
    relationToWizardConditionOperator!: string | undefined;

    constructor(data?: ICreateQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.descriptionShort = _data["descriptionShort"];
            this.descriptionLong = _data["descriptionLong"];
            this.language = _data["language"];
            this.referenceDisplayText = _data["referenceDisplayText"];
            this.reference = _data["reference"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.condition = _data["condition"];
            this.answerOptionSetId = _data["answerOptionSetId"];
            this.panelId = _data["panelId"];
            this.expression = _data["expression"];
            this.defaultValue = _data["defaultValue"];
            this.readOnly = _data["readOnly"];
            this.isRequired = _data["isRequired"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.moduleConditions = _data["moduleConditions"];
            this.moduleConditionsV1 = _data["moduleConditionsV1"];
            this.relationToWizardConditionOperator = _data["relationToWizardConditionOperator"];
        }
    }

    static fromJS(data: any): CreateQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["descriptionShort"] = this.descriptionShort;
        data["descriptionLong"] = this.descriptionLong;
        data["language"] = this.language;
        data["referenceDisplayText"] = this.referenceDisplayText;
        data["reference"] = this.reference;
        data["name"] = this.name;
        data["order"] = this.order;
        data["condition"] = this.condition;
        data["answerOptionSetId"] = this.answerOptionSetId;
        data["panelId"] = this.panelId;
        data["expression"] = this.expression;
        data["defaultValue"] = this.defaultValue;
        data["readOnly"] = this.readOnly;
        data["isRequired"] = this.isRequired;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["moduleConditions"] = this.moduleConditions;
        data["moduleConditionsV1"] = this.moduleConditionsV1;
        data["relationToWizardConditionOperator"] = this.relationToWizardConditionOperator;
        return data;
    }
}

export interface ICreateQuestionRequest {
    title: string | undefined;
    descriptionShort: string | undefined;
    descriptionLong: string | undefined;
    language: string | undefined;
    referenceDisplayText: string | undefined;
    reference: string | undefined;
    name: string | undefined;
    order: number | undefined;
    condition: string | undefined;
    answerOptionSetId: string;
    panelId: string;
    expression: string | undefined;
    defaultValue: string | undefined;
    readOnly: boolean;
    isRequired: boolean;
    regardingObjectTypeId: string | undefined;
    moduleConditions: string | undefined;
    moduleConditionsV1: string | undefined;
    relationToWizardConditionOperator: string | undefined;
}

export class CreateQuestionTranslationRequest implements ICreateQuestionTranslationRequest {
    title!: string | undefined;
    descriptionShort!: string | undefined;
    descriptionLong!: string | undefined;
    language!: string | undefined;
    questionId!: string;
    referenceDisplayText!: string | undefined;
    reference!: string | undefined;

    constructor(data?: ICreateQuestionTranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.descriptionShort = _data["descriptionShort"];
            this.descriptionLong = _data["descriptionLong"];
            this.language = _data["language"];
            this.questionId = _data["questionId"];
            this.referenceDisplayText = _data["referenceDisplayText"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): CreateQuestionTranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionTranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["descriptionShort"] = this.descriptionShort;
        data["descriptionLong"] = this.descriptionLong;
        data["language"] = this.language;
        data["questionId"] = this.questionId;
        data["referenceDisplayText"] = this.referenceDisplayText;
        data["reference"] = this.reference;
        return data;
    }
}

export interface ICreateQuestionTranslationRequest {
    title: string | undefined;
    descriptionShort: string | undefined;
    descriptionLong: string | undefined;
    language: string | undefined;
    questionId: string;
    referenceDisplayText: string | undefined;
    reference: string | undefined;
}

export class CreateRoleRequest implements ICreateRoleRequest {
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: ICreateRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateRoleRequest {
    name: string | undefined;
    description: string | undefined;
}

export class CreateSectionRequest implements ICreateSectionRequest {
    organizationId!: string;
    nameShort!: string | undefined;
    descriptionShort!: string | undefined;
    language!: string | undefined;
    name!: string;
    icon!: string | undefined;
    order!: number;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: ICreateSectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.nameShort = _data["nameShort"];
            this.descriptionShort = _data["descriptionShort"];
            this.language = _data["language"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.order = _data["order"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["nameShort"] = this.nameShort;
        data["descriptionShort"] = this.descriptionShort;
        data["language"] = this.language;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["order"] = this.order;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateSectionRequest {
    organizationId: string;
    nameShort: string | undefined;
    descriptionShort: string | undefined;
    language: string | undefined;
    name: string;
    icon: string | undefined;
    order: number;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class CreateSectionTranslationRequest implements ICreateSectionTranslationRequest {
    sectionId!: string;
    nameShort!: string | undefined;
    descriptionShort!: string | undefined;
    language!: string | undefined;

    constructor(data?: ICreateSectionTranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.nameShort = _data["nameShort"];
            this.descriptionShort = _data["descriptionShort"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): CreateSectionTranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSectionTranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["nameShort"] = this.nameShort;
        data["descriptionShort"] = this.descriptionShort;
        data["language"] = this.language;
        return data;
    }
}

export interface ICreateSectionTranslationRequest {
    sectionId: string;
    nameShort: string | undefined;
    descriptionShort: string | undefined;
    language: string | undefined;
}

export class CreateTasksRequest implements ICreateTasksRequest {
    responsibleIds!: string[] | undefined;
    name!: string | undefined;
    dueTime!: string;
    endDate!: dayjs.Dayjs;
    dueDate!: dayjs.Dayjs;
    dayOfWeek!: number | undefined;
    dayOfMonth!: number | undefined;
    monthOfYear!: number | undefined;
    description!: string | undefined;
    regardingObjectId!: string | undefined;
    regardingObjectTypeId!: string | undefined;
    recurrenceTypeId!: string;
    progression!: string | undefined;
    progressPercentage!: number | undefined;
    approvalFlowId!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: ICreateTasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responsibleIds"])) {
                this.responsibleIds = [] as any;
                for (let item of _data["responsibleIds"])
                    this.responsibleIds!.push(item);
            }
            this.name = _data["name"];
            this.dueTime = _data["dueTime"];
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? dayjs(_data["dueDate"].toString()) : <any>undefined;
            this.dayOfWeek = _data["dayOfWeek"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.monthOfYear = _data["monthOfYear"];
            this.description = _data["description"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.progression = _data["progression"];
            this.progressPercentage = _data["progressPercentage"];
            this.approvalFlowId = _data["approvalFlowId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responsibleIds)) {
            data["responsibleIds"] = [];
            for (let item of this.responsibleIds)
                data["responsibleIds"].push(item);
        }
        data["name"] = this.name;
        data["dueTime"] = this.dueTime;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dayOfWeek"] = this.dayOfWeek;
        data["dayOfMonth"] = this.dayOfMonth;
        data["monthOfYear"] = this.monthOfYear;
        data["description"] = this.description;
        data["regardingObjectId"] = this.regardingObjectId;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["progression"] = this.progression;
        data["progressPercentage"] = this.progressPercentage;
        data["approvalFlowId"] = this.approvalFlowId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateTasksRequest {
    responsibleIds: string[] | undefined;
    name: string | undefined;
    dueTime: string;
    endDate: dayjs.Dayjs;
    dueDate: dayjs.Dayjs;
    dayOfWeek: number | undefined;
    dayOfMonth: number | undefined;
    monthOfYear: number | undefined;
    description: string | undefined;
    regardingObjectId: string | undefined;
    regardingObjectTypeId: string | undefined;
    recurrenceTypeId: string;
    progression: string | undefined;
    progressPercentage: number | undefined;
    approvalFlowId: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class CreateTasksRequestV2 implements ICreateTasksRequestV2 {
    responsibleIds!: string[] | undefined;
    daysOfWeek!: string[] | undefined;
    repeat!: number;
    recurrenceTypeCode!: number;
    occurenceBy!: string | undefined;
    dayNameOfTheMonth!: string | undefined;
    weekOfTheMonth!: number;
    dayOfTheMonth!: number;
    taskEntitiesList!: TaskEntities[] | undefined;
    name!: string | undefined;
    dueTime!: string;
    endDate!: dayjs.Dayjs;
    dueDate!: dayjs.Dayjs;
    dayOfWeek!: number | undefined;
    dayOfMonth!: number | undefined;
    monthOfYear!: number | undefined;
    description!: string | undefined;
    regardingObjectId!: string | undefined;
    regardingObjectTypeId!: string | undefined;
    recurrenceTypeId!: string;
    progression!: string | undefined;
    progressPercentage!: number | undefined;
    approvalFlowId!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: ICreateTasksRequestV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responsibleIds"])) {
                this.responsibleIds = [] as any;
                for (let item of _data["responsibleIds"])
                    this.responsibleIds!.push(item);
            }
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(item);
            }
            this.repeat = _data["repeat"];
            this.recurrenceTypeCode = _data["recurrenceTypeCode"];
            this.occurenceBy = _data["occurenceBy"];
            this.dayNameOfTheMonth = _data["dayNameOfTheMonth"];
            this.weekOfTheMonth = _data["weekOfTheMonth"];
            this.dayOfTheMonth = _data["dayOfTheMonth"];
            if (Array.isArray(_data["taskEntitiesList"])) {
                this.taskEntitiesList = [] as any;
                for (let item of _data["taskEntitiesList"])
                    this.taskEntitiesList!.push(TaskEntities.fromJS(item));
            }
            this.name = _data["name"];
            this.dueTime = _data["dueTime"];
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? dayjs(_data["dueDate"].toString()) : <any>undefined;
            this.dayOfWeek = _data["dayOfWeek"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.monthOfYear = _data["monthOfYear"];
            this.description = _data["description"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.progression = _data["progression"];
            this.progressPercentage = _data["progressPercentage"];
            this.approvalFlowId = _data["approvalFlowId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTasksRequestV2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTasksRequestV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responsibleIds)) {
            data["responsibleIds"] = [];
            for (let item of this.responsibleIds)
                data["responsibleIds"].push(item);
        }
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item);
        }
        data["repeat"] = this.repeat;
        data["recurrenceTypeCode"] = this.recurrenceTypeCode;
        data["occurenceBy"] = this.occurenceBy;
        data["dayNameOfTheMonth"] = this.dayNameOfTheMonth;
        data["weekOfTheMonth"] = this.weekOfTheMonth;
        data["dayOfTheMonth"] = this.dayOfTheMonth;
        if (Array.isArray(this.taskEntitiesList)) {
            data["taskEntitiesList"] = [];
            for (let item of this.taskEntitiesList)
                data["taskEntitiesList"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["dueTime"] = this.dueTime;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dayOfWeek"] = this.dayOfWeek;
        data["dayOfMonth"] = this.dayOfMonth;
        data["monthOfYear"] = this.monthOfYear;
        data["description"] = this.description;
        data["regardingObjectId"] = this.regardingObjectId;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["progression"] = this.progression;
        data["progressPercentage"] = this.progressPercentage;
        data["approvalFlowId"] = this.approvalFlowId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateTasksRequestV2 {
    responsibleIds: string[] | undefined;
    daysOfWeek: string[] | undefined;
    repeat: number;
    recurrenceTypeCode: number;
    occurenceBy: string | undefined;
    dayNameOfTheMonth: string | undefined;
    weekOfTheMonth: number;
    dayOfTheMonth: number;
    taskEntitiesList: TaskEntities[] | undefined;
    name: string | undefined;
    dueTime: string;
    endDate: dayjs.Dayjs;
    dueDate: dayjs.Dayjs;
    dayOfWeek: number | undefined;
    dayOfMonth: number | undefined;
    monthOfYear: number | undefined;
    description: string | undefined;
    regardingObjectId: string | undefined;
    regardingObjectTypeId: string | undefined;
    recurrenceTypeId: string;
    progression: string | undefined;
    progressPercentage: number | undefined;
    approvalFlowId: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class CreateTeamRequest implements ICreateTeamRequest {
    organizationId!: string;
    name!: string | undefined;
    description!: string | undefined;
    email!: string | undefined;

    constructor(data?: ICreateTeamRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateTeamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateTeamRequest {
    organizationId: string;
    name: string | undefined;
    description: string | undefined;
    email: string | undefined;
}

export class CustomFieldValues implements ICustomFieldValues {
    id!: string;
    dataTypeCode!: number;
    displayTypeCode!: number;
    dataType!: string | undefined;
    displayType!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    customFieldDisplayTypeId!: string | undefined;
    customFieldDataTypeId!: string | undefined;
    regardingObjectTypeId!: string;
    isRequired!: boolean;
    validationMessage!: string | undefined;
    lookupFieldReferenceTypeId!: string | undefined;
    entityName!: string | undefined;
    lookupFieldReferenceLockState!: boolean;
    tagBoxValues!: TagBoxValue[] | undefined;

    constructor(data?: ICustomFieldValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataTypeCode = _data["dataTypeCode"];
            this.displayTypeCode = _data["displayTypeCode"];
            this.dataType = _data["dataType"];
            this.displayType = _data["displayType"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.customFieldDisplayTypeId = _data["customFieldDisplayTypeId"];
            this.customFieldDataTypeId = _data["customFieldDataTypeId"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.isRequired = _data["isRequired"];
            this.validationMessage = _data["validationMessage"];
            this.lookupFieldReferenceTypeId = _data["lookupFieldReferenceTypeId"];
            this.entityName = _data["entityName"];
            this.lookupFieldReferenceLockState = _data["lookupFieldReferenceLockState"];
            if (Array.isArray(_data["tagBoxValues"])) {
                this.tagBoxValues = [] as any;
                for (let item of _data["tagBoxValues"])
                    this.tagBoxValues!.push(TagBoxValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomFieldValues {
        data = typeof data === 'object' ? data : {};
        let result = new CustomFieldValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataTypeCode"] = this.dataTypeCode;
        data["displayTypeCode"] = this.displayTypeCode;
        data["dataType"] = this.dataType;
        data["displayType"] = this.displayType;
        data["name"] = this.name;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["customFieldDisplayTypeId"] = this.customFieldDisplayTypeId;
        data["customFieldDataTypeId"] = this.customFieldDataTypeId;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["isRequired"] = this.isRequired;
        data["validationMessage"] = this.validationMessage;
        data["lookupFieldReferenceTypeId"] = this.lookupFieldReferenceTypeId;
        data["entityName"] = this.entityName;
        data["lookupFieldReferenceLockState"] = this.lookupFieldReferenceLockState;
        if (Array.isArray(this.tagBoxValues)) {
            data["tagBoxValues"] = [];
            for (let item of this.tagBoxValues)
                data["tagBoxValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomFieldValues {
    id: string;
    dataTypeCode: number;
    displayTypeCode: number;
    dataType: string | undefined;
    displayType: string | undefined;
    name: string | undefined;
    value: string | undefined;
    displayText: string | undefined;
    customFieldDisplayTypeId: string | undefined;
    customFieldDataTypeId: string | undefined;
    regardingObjectTypeId: string;
    isRequired: boolean;
    validationMessage: string | undefined;
    lookupFieldReferenceTypeId: string | undefined;
    entityName: string | undefined;
    lookupFieldReferenceLockState: boolean;
    tagBoxValues: TagBoxValue[] | undefined;
}

export class DefaultRowValue implements IDefaultRowValue {
    user!: string | undefined;

    constructor(data?: IDefaultRowValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): DefaultRowValue {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultRowValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        return data;
    }
}

export interface IDefaultRowValue {
    user: string | undefined;
}

export class DeleteCustomEntityValueRequest implements IDeleteCustomEntityValueRequest {
    id!: string;

    constructor(data?: IDeleteCustomEntityValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteCustomEntityValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCustomEntityValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteCustomEntityValueRequest {
    id: string;
}

export class DeleteMultipleProcessesRequest implements IDeleteMultipleProcessesRequest {
    idList!: string[] | undefined;

    constructor(data?: IDeleteMultipleProcessesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["idList"])) {
                this.idList = [] as any;
                for (let item of _data["idList"])
                    this.idList!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteMultipleProcessesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMultipleProcessesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idList)) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        return data;
    }
}

export interface IDeleteMultipleProcessesRequest {
    idList: string[] | undefined;
}

export class DeleteOrganizationUserRequest implements IDeleteOrganizationUserRequest {
    id!: string;
    organzationId!: string;

    constructor(data?: IDeleteOrganizationUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organzationId = _data["organzationId"];
        }
    }

    static fromJS(data: any): DeleteOrganizationUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrganizationUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organzationId"] = this.organzationId;
        return data;
    }
}

export interface IDeleteOrganizationUserRequest {
    id: string;
    organzationId: string;
}

export class DeleteProcessTranslationRequest implements IDeleteProcessTranslationRequest {
    id!: string;

    constructor(data?: IDeleteProcessTranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteProcessTranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProcessTranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteProcessTranslationRequest {
    id: string;
}

export class DeleteQuestionRequest implements IDeleteQuestionRequest {
    id!: string;

    constructor(data?: IDeleteQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteQuestionRequest {
    id: string;
}

export class DeleteQuestionTranslationRequest implements IDeleteQuestionTranslationRequest {
    id!: string;

    constructor(data?: IDeleteQuestionTranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteQuestionTranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteQuestionTranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteQuestionTranslationRequest {
    id: string;
}

export class DeleteReportTemplateRequest implements IDeleteReportTemplateRequest {
    id!: string;

    constructor(data?: IDeleteReportTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteReportTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteReportTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteReportTemplateRequest {
    id: string;
}

export class DeleteRequest implements IDeleteRequest {
    id!: string;

    constructor(data?: IDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteRequest {
    id: string;
}

export class DeleteRoleRequest implements IDeleteRoleRequest {
    id!: string;

    constructor(data?: IDeleteRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteRoleRequest {
    id: string;
}

export class DeleteSectionRequest implements IDeleteSectionRequest {
    id!: string;

    constructor(data?: IDeleteSectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSectionRequest {
    id: string;
}

export class DeleteSectionTranslationRequest implements IDeleteSectionTranslationRequest {
    id!: string;

    constructor(data?: IDeleteSectionTranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSectionTranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSectionTranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSectionTranslationRequest {
    id: string;
}

export class DeleteTasksRequest implements IDeleteTasksRequest {
    id!: string;
    isSeries!: boolean;

    constructor(data?: IDeleteTasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isSeries = _data["isSeries"];
        }
    }

    static fromJS(data: any): DeleteTasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isSeries"] = this.isSeries;
        return data;
    }
}

export interface IDeleteTasksRequest {
    id: string;
    isSeries: boolean;
}

export class DeleteTeamRequest implements IDeleteTeamRequest {
    id!: string;

    constructor(data?: IDeleteTeamRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteTeamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTeamRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteTeamRequest {
    id: string;
}

export class DeleteUserRequest implements IDeleteUserRequest {
    id!: string;

    constructor(data?: IDeleteUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteUserRequest {
    id: string;
}

export class DownloadOrganizationReportResponse implements IDownloadOrganizationReportResponse {
    name!: string | undefined;
    contentType!: string | undefined;
    contentStream!: MemoryStream;

    constructor(data?: IDownloadOrganizationReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.contentType = _data["contentType"];
            this.contentStream = _data["contentStream"] ? MemoryStream.fromJS(_data["contentStream"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadOrganizationReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadOrganizationReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["contentType"] = this.contentType;
        data["contentStream"] = this.contentStream ? this.contentStream.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDownloadOrganizationReportResponse {
    name: string | undefined;
    contentType: string | undefined;
    contentStream: MemoryStream;
}

export class DownloadReportTemplateResponse implements IDownloadReportTemplateResponse {
    name!: string | undefined;
    contentType!: string | undefined;
    contentStream!: MemoryStream;

    constructor(data?: IDownloadReportTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.contentType = _data["contentType"];
            this.contentStream = _data["contentStream"] ? MemoryStream.fromJS(_data["contentStream"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadReportTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadReportTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["contentType"] = this.contentType;
        data["contentStream"] = this.contentStream ? this.contentStream.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDownloadReportTemplateResponse {
    name: string | undefined;
    contentType: string | undefined;
    contentStream: MemoryStream;
}

export class DownloadSingleProcessReportResponse implements IDownloadSingleProcessReportResponse {
    name!: string | undefined;
    contentType!: string | undefined;
    contentStream!: MemoryStream;

    constructor(data?: IDownloadSingleProcessReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.contentType = _data["contentType"];
            this.contentStream = _data["contentStream"] ? MemoryStream.fromJS(_data["contentStream"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DownloadSingleProcessReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadSingleProcessReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["contentType"] = this.contentType;
        data["contentStream"] = this.contentStream ? this.contentStream.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDownloadSingleProcessReportResponse {
    name: string | undefined;
    contentType: string | undefined;
    contentStream: MemoryStream;
}

export class DuplicateWizardRequest implements IDuplicateWizardRequest {
    id!: string;

    constructor(data?: IDuplicateWizardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DuplicateWizardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateWizardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDuplicateWizardRequest {
    id: string;
}

export class Element implements IElement {
    id!: string;
    type!: string | undefined;
    name!: string | undefined;
    order!: number;
    title!: string | undefined;
    description!: string | undefined;
    visibleIf!: string | undefined;
    elements!: Question[] | undefined;
    interWizard!: boolean;

    constructor(data?: IElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.visibleIf = _data["visibleIf"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(Question.fromJS(item));
            }
            this.interWizard = _data["interWizard"];
        }
    }

    static fromJS(data: any): Element {
        data = typeof data === 'object' ? data : {};
        let result = new Element();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["order"] = this.order;
        data["title"] = this.title;
        data["description"] = this.description;
        data["visibleIf"] = this.visibleIf;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["interWizard"] = this.interWizard;
        return data;
    }
}

export interface IElement {
    id: string;
    type: string | undefined;
    name: string | undefined;
    order: number;
    title: string | undefined;
    description: string | undefined;
    visibleIf: string | undefined;
    elements: Question[] | undefined;
    interWizard: boolean;
}

export class ExternalProvider implements IExternalProvider {
    loginProvider!: string | undefined;
    providerKey!: string | undefined;

    constructor(data?: IExternalProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): ExternalProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }
}

export interface IExternalProvider {
    loginProvider: string | undefined;
    providerKey: string | undefined;
}

export class GetAllOrganizationsResponse implements IGetAllOrganizationsResponse {
    id!: string;
    partnerName!: string | undefined;
    systems!: OrganizationSystems[] | undefined;
    userId!: string;
    organizationId!: string;
    isDefault!: boolean;
    isFavorite!: boolean;
    userEmail!: string | undefined;
    defaultLanguage!: string | undefined;
    b2CId!: string;
    isPartnerFavourite!: boolean;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: IGetAllOrganizationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerName = _data["partnerName"];
            if (Array.isArray(_data["systems"])) {
                this.systems = [] as any;
                for (let item of _data["systems"])
                    this.systems!.push(OrganizationSystems.fromJS(item));
            }
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
            this.isDefault = _data["isDefault"];
            this.isFavorite = _data["isFavorite"];
            this.userEmail = _data["userEmail"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.b2CId = _data["b2CId"];
            this.isPartnerFavourite = _data["isPartnerFavourite"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): GetAllOrganizationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOrganizationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerName"] = this.partnerName;
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item.toJSON());
        }
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        data["isDefault"] = this.isDefault;
        data["isFavorite"] = this.isFavorite;
        data["userEmail"] = this.userEmail;
        data["defaultLanguage"] = this.defaultLanguage;
        data["b2CId"] = this.b2CId;
        data["isPartnerFavourite"] = this.isPartnerFavourite;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface IGetAllOrganizationsResponse {
    id: string;
    partnerName: string | undefined;
    systems: OrganizationSystems[] | undefined;
    userId: string;
    organizationId: string;
    isDefault: boolean;
    isFavorite: boolean;
    userEmail: string | undefined;
    defaultLanguage: string | undefined;
    b2CId: string;
    isPartnerFavourite: boolean;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class GetAllPartnersResponse implements IGetAllPartnersResponse {
    id!: string;
    systems!: OrganizationSystems[] | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: IGetAllPartnersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["systems"])) {
                this.systems = [] as any;
                for (let item of _data["systems"])
                    this.systems!.push(OrganizationSystems.fromJS(item));
            }
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): GetAllPartnersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPartnersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.systems)) {
            data["systems"] = [];
            for (let item of this.systems)
                data["systems"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface IGetAllPartnersResponse {
    id: string;
    systems: OrganizationSystems[] | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class GetAllQuestionResponse implements IGetAllQuestionResponse {
    id!: string;
    answerOptionSet!: string | undefined;
    panelName!: string | undefined;
    pageName!: string | undefined;
    pageId!: string;
    wizardName!: string | undefined;
    wizardId!: string;
    questionCode!: string;
    name!: string | undefined;
    order!: number | undefined;
    condition!: string | undefined;
    answerOptionSetId!: string;
    panelId!: string;
    expression!: string | undefined;
    defaultValue!: string | undefined;
    readOnly!: boolean;
    isRequired!: boolean;
    regardingObjectTypeId!: string | undefined;
    moduleConditions!: string | undefined;
    moduleConditionsV1!: string | undefined;
    relationToWizardConditionOperator!: string | undefined;

    constructor(data?: IGetAllQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answerOptionSet = _data["answerOptionSet"];
            this.panelName = _data["panelName"];
            this.pageName = _data["pageName"];
            this.pageId = _data["pageId"];
            this.wizardName = _data["wizardName"];
            this.wizardId = _data["wizardId"];
            this.questionCode = _data["questionCode"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.condition = _data["condition"];
            this.answerOptionSetId = _data["answerOptionSetId"];
            this.panelId = _data["panelId"];
            this.expression = _data["expression"];
            this.defaultValue = _data["defaultValue"];
            this.readOnly = _data["readOnly"];
            this.isRequired = _data["isRequired"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.moduleConditions = _data["moduleConditions"];
            this.moduleConditionsV1 = _data["moduleConditionsV1"];
            this.relationToWizardConditionOperator = _data["relationToWizardConditionOperator"];
        }
    }

    static fromJS(data: any): GetAllQuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllQuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answerOptionSet"] = this.answerOptionSet;
        data["panelName"] = this.panelName;
        data["pageName"] = this.pageName;
        data["pageId"] = this.pageId;
        data["wizardName"] = this.wizardName;
        data["wizardId"] = this.wizardId;
        data["questionCode"] = this.questionCode;
        data["name"] = this.name;
        data["order"] = this.order;
        data["condition"] = this.condition;
        data["answerOptionSetId"] = this.answerOptionSetId;
        data["panelId"] = this.panelId;
        data["expression"] = this.expression;
        data["defaultValue"] = this.defaultValue;
        data["readOnly"] = this.readOnly;
        data["isRequired"] = this.isRequired;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["moduleConditions"] = this.moduleConditions;
        data["moduleConditionsV1"] = this.moduleConditionsV1;
        data["relationToWizardConditionOperator"] = this.relationToWizardConditionOperator;
        return data;
    }
}

export interface IGetAllQuestionResponse {
    id: string;
    answerOptionSet: string | undefined;
    panelName: string | undefined;
    pageName: string | undefined;
    pageId: string;
    wizardName: string | undefined;
    wizardId: string;
    questionCode: string;
    name: string | undefined;
    order: number | undefined;
    condition: string | undefined;
    answerOptionSetId: string;
    panelId: string;
    expression: string | undefined;
    defaultValue: string | undefined;
    readOnly: boolean;
    isRequired: boolean;
    regardingObjectTypeId: string | undefined;
    moduleConditions: string | undefined;
    moduleConditionsV1: string | undefined;
    relationToWizardConditionOperator: string | undefined;
}

export class GetAllSectionProcessesResponse implements IGetAllSectionProcessesResponse {
    id!: string;
    nameShort!: string | undefined;
    descriptionShort!: string | undefined;
    icon!: string | undefined;
    order!: number;
    regardingObjectTypeId!: string;
    processes!: GetSectionProcessResponse[] | undefined;

    constructor(data?: IGetAllSectionProcessesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameShort = _data["nameShort"];
            this.descriptionShort = _data["descriptionShort"];
            this.icon = _data["icon"];
            this.order = _data["order"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            if (Array.isArray(_data["processes"])) {
                this.processes = [] as any;
                for (let item of _data["processes"])
                    this.processes!.push(GetSectionProcessResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllSectionProcessesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSectionProcessesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameShort"] = this.nameShort;
        data["descriptionShort"] = this.descriptionShort;
        data["icon"] = this.icon;
        data["order"] = this.order;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        if (Array.isArray(this.processes)) {
            data["processes"] = [];
            for (let item of this.processes)
                data["processes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllSectionProcessesResponse {
    id: string;
    nameShort: string | undefined;
    descriptionShort: string | undefined;
    icon: string | undefined;
    order: number;
    regardingObjectTypeId: string;
    processes: GetSectionProcessResponse[] | undefined;
}

export class GetApprovalFlowProgressResponse implements IGetApprovalFlowProgressResponse {
    id!: string;
    approvalProgresses!: ApprovalsProgress[] | undefined;
    approvalFlowState!: number;
    approverId!: string;
    comments!: string | undefined;
    stateChangedOn!: dayjs.Dayjs;
    commentOnApprove!: boolean;
    commentOnReject!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    enable!: boolean;
    approvalOrder!: number;

    constructor(data?: IGetApprovalFlowProgressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["approvalProgresses"])) {
                this.approvalProgresses = [] as any;
                for (let item of _data["approvalProgresses"])
                    this.approvalProgresses!.push(ApprovalsProgress.fromJS(item));
            }
            this.approvalFlowState = _data["approvalFlowState"];
            this.approverId = _data["approverId"];
            this.comments = _data["comments"];
            this.stateChangedOn = _data["stateChangedOn"] ? dayjs(_data["stateChangedOn"].toString()) : <any>undefined;
            this.commentOnApprove = _data["commentOnApprove"];
            this.commentOnReject = _data["commentOnReject"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enable = _data["enable"];
            this.approvalOrder = _data["approvalOrder"];
        }
    }

    static fromJS(data: any): GetApprovalFlowProgressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApprovalFlowProgressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.approvalProgresses)) {
            data["approvalProgresses"] = [];
            for (let item of this.approvalProgresses)
                data["approvalProgresses"].push(item.toJSON());
        }
        data["approvalFlowState"] = this.approvalFlowState;
        data["approverId"] = this.approverId;
        data["comments"] = this.comments;
        data["stateChangedOn"] = this.stateChangedOn ? this.stateChangedOn.toISOString() : <any>undefined;
        data["commentOnApprove"] = this.commentOnApprove;
        data["commentOnReject"] = this.commentOnReject;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enable"] = this.enable;
        data["approvalOrder"] = this.approvalOrder;
        return data;
    }
}

export interface IGetApprovalFlowProgressResponse {
    id: string;
    approvalProgresses: ApprovalsProgress[] | undefined;
    approvalFlowState: number;
    approverId: string;
    comments: string | undefined;
    stateChangedOn: dayjs.Dayjs;
    commentOnApprove: boolean;
    commentOnReject: boolean;
    name: string | undefined;
    description: string | undefined;
    enable: boolean;
    approvalOrder: number;
}

export class GetApprovalFlowsHistoryResponse implements IGetApprovalFlowsHistoryResponse {
    id!: string;
    userId!: string;
    approvalFlowState!: number;
    regardingObjectType!: string | undefined;
    regardingObjectTypeId!: string;
    regardingObject!: string | undefined;
    regardingObjectId!: string;
    triggerTime!: dayjs.Dayjs;
    time!: string | undefined;
    comments!: string | undefined;
    userName!: string | undefined;
    updatedAtTime!: dayjs.Dayjs;
    updateTime!: string | undefined;
    wizardId!: string | undefined;
    flowEngineStepId!: string | undefined;
    flowEngineStepName!: string | undefined;
    dataVersion!: string | undefined;
    approvalStepDetails!: ApprovalStepDetail;
    flowEngineHistoryLogId!: string;
    icon!: string | undefined;
    commentOnApprove!: boolean;
    commentOnReject!: boolean;
    autoApproveForTriggerer!: boolean;
    flowEngineID!: string;
    organizationId!: string;

    constructor(data?: IGetApprovalFlowsHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.approvalFlowState = _data["approvalFlowState"];
            this.regardingObjectType = _data["regardingObjectType"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.regardingObject = _data["regardingObject"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.triggerTime = _data["triggerTime"] ? dayjs(_data["triggerTime"].toString()) : <any>undefined;
            this.time = _data["time"];
            this.comments = _data["comments"];
            this.userName = _data["userName"];
            this.updatedAtTime = _data["updatedAtTime"] ? dayjs(_data["updatedAtTime"].toString()) : <any>undefined;
            this.updateTime = _data["updateTime"];
            this.wizardId = _data["wizardId"];
            this.flowEngineStepId = _data["flowEngineStepId"];
            this.flowEngineStepName = _data["flowEngineStepName"];
            this.dataVersion = _data["dataVersion"];
            this.approvalStepDetails = _data["approvalStepDetails"] ? ApprovalStepDetail.fromJS(_data["approvalStepDetails"]) : <any>undefined;
            this.flowEngineHistoryLogId = _data["flowEngineHistoryLogId"];
            this.icon = _data["icon"];
            this.commentOnApprove = _data["commentOnApprove"];
            this.commentOnReject = _data["commentOnReject"];
            this.autoApproveForTriggerer = _data["autoApproveForTriggerer"];
            this.flowEngineID = _data["flowEngineID"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): GetApprovalFlowsHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApprovalFlowsHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["approvalFlowState"] = this.approvalFlowState;
        data["regardingObjectType"] = this.regardingObjectType;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["regardingObject"] = this.regardingObject;
        data["regardingObjectId"] = this.regardingObjectId;
        data["triggerTime"] = this.triggerTime ? this.triggerTime.toISOString() : <any>undefined;
        data["time"] = this.time;
        data["comments"] = this.comments;
        data["userName"] = this.userName;
        data["updatedAtTime"] = this.updatedAtTime ? this.updatedAtTime.toISOString() : <any>undefined;
        data["updateTime"] = this.updateTime;
        data["wizardId"] = this.wizardId;
        data["flowEngineStepId"] = this.flowEngineStepId;
        data["flowEngineStepName"] = this.flowEngineStepName;
        data["dataVersion"] = this.dataVersion;
        data["approvalStepDetails"] = this.approvalStepDetails ? this.approvalStepDetails.toJSON() : <any>undefined;
        data["flowEngineHistoryLogId"] = this.flowEngineHistoryLogId;
        data["icon"] = this.icon;
        data["commentOnApprove"] = this.commentOnApprove;
        data["commentOnReject"] = this.commentOnReject;
        data["autoApproveForTriggerer"] = this.autoApproveForTriggerer;
        data["flowEngineID"] = this.flowEngineID;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IGetApprovalFlowsHistoryResponse {
    id: string;
    userId: string;
    approvalFlowState: number;
    regardingObjectType: string | undefined;
    regardingObjectTypeId: string;
    regardingObject: string | undefined;
    regardingObjectId: string;
    triggerTime: dayjs.Dayjs;
    time: string | undefined;
    comments: string | undefined;
    userName: string | undefined;
    updatedAtTime: dayjs.Dayjs;
    updateTime: string | undefined;
    wizardId: string | undefined;
    flowEngineStepId: string | undefined;
    flowEngineStepName: string | undefined;
    dataVersion: string | undefined;
    approvalStepDetails: ApprovalStepDetail;
    flowEngineHistoryLogId: string;
    icon: string | undefined;
    commentOnApprove: boolean;
    commentOnReject: boolean;
    autoApproveForTriggerer: boolean;
    flowEngineID: string;
    organizationId: string;
}

export class GetClaimResponse implements IGetClaimResponse {
    id!: string;
    entityName!: string | undefined;
    actionName!: string | undefined;
    sectionName!: string | undefined;
    scopeName!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    regardingObjectTypeId!: string;
    action!: number;
    sectionId!: string | undefined;
    scope!: number;

    constructor(data?: IGetClaimResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityName = _data["entityName"];
            this.actionName = _data["actionName"];
            this.sectionName = _data["sectionName"];
            this.scopeName = _data["scopeName"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.action = _data["action"];
            this.sectionId = _data["sectionId"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): GetClaimResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaimResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityName"] = this.entityName;
        data["actionName"] = this.actionName;
        data["sectionName"] = this.sectionName;
        data["scopeName"] = this.scopeName;
        data["name"] = this.name;
        data["description"] = this.description;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["action"] = this.action;
        data["sectionId"] = this.sectionId;
        data["scope"] = this.scope;
        return data;
    }
}

export interface IGetClaimResponse {
    id: string;
    entityName: string | undefined;
    actionName: string | undefined;
    sectionName: string | undefined;
    scopeName: string | undefined;
    name: string | undefined;
    description: string | undefined;
    regardingObjectTypeId: string;
    action: number;
    sectionId: string | undefined;
    scope: number;
}

export class GetCustomEntityValueResponse implements IGetCustomEntityValueResponse {
    id!: string;
    notification!: boolean;
    attachment!: boolean;
    wizard!: boolean;
    task!: boolean;
    showInMenu!: boolean;
    entityName!: string | undefined;
    responsible!: string | undefined;
    flowEngine!: boolean;
    lock!: boolean;
    parentId!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    regardingObjectTypeId!: string;
    userId!: string | undefined;
    wizardId!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IGetCustomEntityValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notification = _data["notification"];
            this.attachment = _data["attachment"];
            this.wizard = _data["wizard"];
            this.task = _data["task"];
            this.showInMenu = _data["showInMenu"];
            this.entityName = _data["entityName"];
            this.responsible = _data["responsible"];
            this.flowEngine = _data["flowEngine"];
            this.lock = _data["lock"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.userId = _data["userId"];
            this.wizardId = _data["wizardId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCustomEntityValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomEntityValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notification"] = this.notification;
        data["attachment"] = this.attachment;
        data["wizard"] = this.wizard;
        data["task"] = this.task;
        data["showInMenu"] = this.showInMenu;
        data["entityName"] = this.entityName;
        data["responsible"] = this.responsible;
        data["flowEngine"] = this.flowEngine;
        data["lock"] = this.lock;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["userId"] = this.userId;
        data["wizardId"] = this.wizardId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCustomEntityValueResponse {
    id: string;
    notification: boolean;
    attachment: boolean;
    wizard: boolean;
    task: boolean;
    showInMenu: boolean;
    entityName: string | undefined;
    responsible: string | undefined;
    flowEngine: boolean;
    lock: boolean;
    parentId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    regardingObjectTypeId: string;
    userId: string | undefined;
    wizardId: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class GetDashboardProcess implements IGetDashboardProcess {
    id!: string;
    nameShort!: string | undefined;
    nameLong!: string | undefined;

    constructor(data?: IGetDashboardProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameShort = _data["nameShort"];
            this.nameLong = _data["nameLong"];
        }
    }

    static fromJS(data: any): GetDashboardProcess {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameShort"] = this.nameShort;
        data["nameLong"] = this.nameLong;
        return data;
    }
}

export interface IGetDashboardProcess {
    id: string;
    nameShort: string | undefined;
    nameLong: string | undefined;
}

export class GetDashboardResponse implements IGetDashboardResponse {
    children!: Section[] | undefined;
    id!: string;
    name!: string | undefined;
    processingRecordId!: string | undefined;
    parentId!: string | undefined;
    type!: string | undefined;
    state!: string | undefined;
    description!: string | undefined;
    icon!: string | undefined;
    size!: number | undefined;
    accessLevel!: number | undefined;
    reportProcessingRecordId!: string | undefined;
    tags!: string[] | undefined;

    constructor(data?: IGetDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Section.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.processingRecordId = _data["processingRecordId"];
            this.parentId = _data["parentId"];
            this.type = _data["type"];
            this.state = _data["state"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.size = _data["size"];
            this.accessLevel = _data["accessLevel"];
            this.reportProcessingRecordId = _data["reportProcessingRecordId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["processingRecordId"] = this.processingRecordId;
        data["parentId"] = this.parentId;
        data["type"] = this.type;
        data["state"] = this.state;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["size"] = this.size;
        data["accessLevel"] = this.accessLevel;
        data["reportProcessingRecordId"] = this.reportProcessingRecordId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardResponse {
    children: Section[] | undefined;
    id: string;
    name: string | undefined;
    processingRecordId: string | undefined;
    parentId: string | undefined;
    type: string | undefined;
    state: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    size: number | undefined;
    accessLevel: number | undefined;
    reportProcessingRecordId: string | undefined;
    tags: string[] | undefined;
}

export class GetOrganizationResponse implements IGetOrganizationResponse {
    id!: string;
    partnerName!: string | undefined;
    systemIds!: string[] | undefined;
    accountRepresentatives!: AccountRepresentative[] | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: IGetOrganizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerName = _data["partnerName"];
            if (Array.isArray(_data["systemIds"])) {
                this.systemIds = [] as any;
                for (let item of _data["systemIds"])
                    this.systemIds!.push(item);
            }
            if (Array.isArray(_data["accountRepresentatives"])) {
                this.accountRepresentatives = [] as any;
                for (let item of _data["accountRepresentatives"])
                    this.accountRepresentatives!.push(AccountRepresentative.fromJS(item));
            }
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): GetOrganizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerName"] = this.partnerName;
        if (Array.isArray(this.systemIds)) {
            data["systemIds"] = [];
            for (let item of this.systemIds)
                data["systemIds"].push(item);
        }
        if (Array.isArray(this.accountRepresentatives)) {
            data["accountRepresentatives"] = [];
            for (let item of this.accountRepresentatives)
                data["accountRepresentatives"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface IGetOrganizationResponse {
    id: string;
    partnerName: string | undefined;
    systemIds: string[] | undefined;
    accountRepresentatives: AccountRepresentative[] | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class GetPageListResponse implements IGetPageListResponse {
    title!: string | undefined;
    showProgressBar!: string | undefined;
    completeText!: string | undefined;
    pageNextText!: string | undefined;
    pagePrevText!: string | undefined;
    completedHTML!: string | undefined;
    pages!: Pages[] | undefined;
    showCompletedPage!: boolean;
    readonly locale!: string | undefined;
    clearInvisibleValues!: string | undefined;

    constructor(data?: IGetPageListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.showProgressBar = _data["showProgressBar"];
            this.completeText = _data["completeText"];
            this.pageNextText = _data["pageNextText"];
            this.pagePrevText = _data["pagePrevText"];
            this.completedHTML = _data["completedHTML"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Pages.fromJS(item));
            }
            this.showCompletedPage = _data["showCompletedPage"];
            (<any>this).locale = _data["locale"];
            this.clearInvisibleValues = _data["clearInvisibleValues"];
        }
    }

    static fromJS(data: any): GetPageListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPageListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["showProgressBar"] = this.showProgressBar;
        data["completeText"] = this.completeText;
        data["pageNextText"] = this.pageNextText;
        data["pagePrevText"] = this.pagePrevText;
        data["completedHTML"] = this.completedHTML;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        data["showCompletedPage"] = this.showCompletedPage;
        data["locale"] = this.locale;
        data["clearInvisibleValues"] = this.clearInvisibleValues;
        return data;
    }
}

export interface IGetPageListResponse {
    title: string | undefined;
    showProgressBar: string | undefined;
    completeText: string | undefined;
    pageNextText: string | undefined;
    pagePrevText: string | undefined;
    completedHTML: string | undefined;
    pages: Pages[] | undefined;
    showCompletedPage: boolean;
    locale: string | undefined;
    clearInvisibleValues: string | undefined;
}

export class GetProcessResponse implements IGetProcessResponse {
    id!: string;
    responsible!: string | undefined;
    reportName!: string | undefined;
    nameShort!: string | undefined;
    descriptionShort!: string | undefined;
    flowEngine!: boolean;
    lock!: boolean;
    name!: string | undefined;
    sectionId!: string;
    wizardId!: string;
    responsibleId!: string | undefined;
    order!: number;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IGetProcessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsible = _data["responsible"];
            this.reportName = _data["reportName"];
            this.nameShort = _data["nameShort"];
            this.descriptionShort = _data["descriptionShort"];
            this.flowEngine = _data["flowEngine"];
            this.lock = _data["lock"];
            this.name = _data["name"];
            this.sectionId = _data["sectionId"];
            this.wizardId = _data["wizardId"];
            this.responsibleId = _data["responsibleId"];
            this.order = _data["order"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProcessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProcessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsible"] = this.responsible;
        data["reportName"] = this.reportName;
        data["nameShort"] = this.nameShort;
        data["descriptionShort"] = this.descriptionShort;
        data["flowEngine"] = this.flowEngine;
        data["lock"] = this.lock;
        data["name"] = this.name;
        data["sectionId"] = this.sectionId;
        data["wizardId"] = this.wizardId;
        data["responsibleId"] = this.responsibleId;
        data["order"] = this.order;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProcessResponse {
    id: string;
    responsible: string | undefined;
    reportName: string | undefined;
    nameShort: string | undefined;
    descriptionShort: string | undefined;
    flowEngine: boolean;
    lock: boolean;
    name: string | undefined;
    sectionId: string;
    wizardId: string;
    responsibleId: string | undefined;
    order: number;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class GetProcessTranslationResponse implements IGetProcessTranslationResponse {
    id!: string;
    processId!: string;
    nameShort!: string | undefined;
    descriptionShort!: string | undefined;
    language!: string | undefined;

    constructor(data?: IGetProcessTranslationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processId = _data["processId"];
            this.nameShort = _data["nameShort"];
            this.descriptionShort = _data["descriptionShort"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): GetProcessTranslationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProcessTranslationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processId"] = this.processId;
        data["nameShort"] = this.nameShort;
        data["descriptionShort"] = this.descriptionShort;
        data["language"] = this.language;
        return data;
    }
}

export interface IGetProcessTranslationResponse {
    id: string;
    processId: string;
    nameShort: string | undefined;
    descriptionShort: string | undefined;
    language: string | undefined;
}

export class GetQuestionResponse implements IGetQuestionResponse {
    id!: string;
    answerOptionSet!: string | undefined;
    panelName!: string | undefined;
    questionCode!: string;
    name!: string | undefined;
    order!: number | undefined;
    condition!: string | undefined;
    answerOptionSetId!: string;
    panelId!: string;
    expression!: string | undefined;
    defaultValue!: string | undefined;
    readOnly!: boolean;
    isRequired!: boolean;
    regardingObjectTypeId!: string | undefined;
    moduleConditions!: string | undefined;
    moduleConditionsV1!: string | undefined;
    relationToWizardConditionOperator!: string | undefined;

    constructor(data?: IGetQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answerOptionSet = _data["answerOptionSet"];
            this.panelName = _data["panelName"];
            this.questionCode = _data["questionCode"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.condition = _data["condition"];
            this.answerOptionSetId = _data["answerOptionSetId"];
            this.panelId = _data["panelId"];
            this.expression = _data["expression"];
            this.defaultValue = _data["defaultValue"];
            this.readOnly = _data["readOnly"];
            this.isRequired = _data["isRequired"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.moduleConditions = _data["moduleConditions"];
            this.moduleConditionsV1 = _data["moduleConditionsV1"];
            this.relationToWizardConditionOperator = _data["relationToWizardConditionOperator"];
        }
    }

    static fromJS(data: any): GetQuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answerOptionSet"] = this.answerOptionSet;
        data["panelName"] = this.panelName;
        data["questionCode"] = this.questionCode;
        data["name"] = this.name;
        data["order"] = this.order;
        data["condition"] = this.condition;
        data["answerOptionSetId"] = this.answerOptionSetId;
        data["panelId"] = this.panelId;
        data["expression"] = this.expression;
        data["defaultValue"] = this.defaultValue;
        data["readOnly"] = this.readOnly;
        data["isRequired"] = this.isRequired;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["moduleConditions"] = this.moduleConditions;
        data["moduleConditionsV1"] = this.moduleConditionsV1;
        data["relationToWizardConditionOperator"] = this.relationToWizardConditionOperator;
        return data;
    }
}

export interface IGetQuestionResponse {
    id: string;
    answerOptionSet: string | undefined;
    panelName: string | undefined;
    questionCode: string;
    name: string | undefined;
    order: number | undefined;
    condition: string | undefined;
    answerOptionSetId: string;
    panelId: string;
    expression: string | undefined;
    defaultValue: string | undefined;
    readOnly: boolean;
    isRequired: boolean;
    regardingObjectTypeId: string | undefined;
    moduleConditions: string | undefined;
    moduleConditionsV1: string | undefined;
    relationToWizardConditionOperator: string | undefined;
}

export class GetRegardingObjectQuestionAnswersResponse implements IGetRegardingObjectQuestionAnswersResponse {
    questionId!: string;
    answerOptionsSetValues!: string[] | undefined;
    answer!: string | undefined;
    dateSelected!: dayjs.Dayjs | undefined;
    user!: string | undefined;
    answerDisplayTypeCode!: number;
    answerTypeCode!: number;
    isSeen!: boolean;
    tagBoxSelectedValues!: TagBoxSelectedValue[] | undefined;

    constructor(data?: IGetRegardingObjectQuestionAnswersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            if (Array.isArray(_data["answerOptionsSetValues"])) {
                this.answerOptionsSetValues = [] as any;
                for (let item of _data["answerOptionsSetValues"])
                    this.answerOptionsSetValues!.push(item);
            }
            this.answer = _data["answer"];
            this.dateSelected = _data["dateSelected"] ? dayjs(_data["dateSelected"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.answerDisplayTypeCode = _data["answerDisplayTypeCode"];
            this.answerTypeCode = _data["answerTypeCode"];
            this.isSeen = _data["isSeen"];
            if (Array.isArray(_data["tagBoxSelectedValues"])) {
                this.tagBoxSelectedValues = [] as any;
                for (let item of _data["tagBoxSelectedValues"])
                    this.tagBoxSelectedValues!.push(TagBoxSelectedValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegardingObjectQuestionAnswersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegardingObjectQuestionAnswersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        if (Array.isArray(this.answerOptionsSetValues)) {
            data["answerOptionsSetValues"] = [];
            for (let item of this.answerOptionsSetValues)
                data["answerOptionsSetValues"].push(item);
        }
        data["answer"] = this.answer;
        data["dateSelected"] = this.dateSelected ? this.dateSelected.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["answerDisplayTypeCode"] = this.answerDisplayTypeCode;
        data["answerTypeCode"] = this.answerTypeCode;
        data["isSeen"] = this.isSeen;
        if (Array.isArray(this.tagBoxSelectedValues)) {
            data["tagBoxSelectedValues"] = [];
            for (let item of this.tagBoxSelectedValues)
                data["tagBoxSelectedValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRegardingObjectQuestionAnswersResponse {
    questionId: string;
    answerOptionsSetValues: string[] | undefined;
    answer: string | undefined;
    dateSelected: dayjs.Dayjs | undefined;
    user: string | undefined;
    answerDisplayTypeCode: number;
    answerTypeCode: number;
    isSeen: boolean;
    tagBoxSelectedValues: TagBoxSelectedValue[] | undefined;
}

export class GetRegardingObjectTypeResponse implements IGetRegardingObjectTypeResponse {
    id!: string;
    code!: number;
    pluralName!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    language!: string | undefined;
    platormEntity!: boolean;
    type!: boolean;
    name!: string | undefined;
    attachment!: boolean;
    wizard!: boolean;
    task!: boolean;
    showInMenu!: boolean;
    publish!: boolean;
    organizationId!: string | undefined;
    wizardId!: string | undefined;
    quickCreate!: boolean;
    externalQuestionnaire!: boolean;
    readonly searchInWizard!: boolean;

    constructor(data?: IGetRegardingObjectTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.pluralName = _data["pluralName"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.language = _data["language"];
            this.platormEntity = _data["platormEntity"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.attachment = _data["attachment"];
            this.wizard = _data["wizard"];
            this.task = _data["task"];
            this.showInMenu = _data["showInMenu"];
            this.publish = _data["publish"];
            this.organizationId = _data["organizationId"];
            this.wizardId = _data["wizardId"];
            this.quickCreate = _data["quickCreate"];
            this.externalQuestionnaire = _data["externalQuestionnaire"];
            (<any>this).searchInWizard = _data["searchInWizard"];
        }
    }

    static fromJS(data: any): GetRegardingObjectTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegardingObjectTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["pluralName"] = this.pluralName;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["language"] = this.language;
        data["platormEntity"] = this.platormEntity;
        data["type"] = this.type;
        data["name"] = this.name;
        data["attachment"] = this.attachment;
        data["wizard"] = this.wizard;
        data["task"] = this.task;
        data["showInMenu"] = this.showInMenu;
        data["publish"] = this.publish;
        data["organizationId"] = this.organizationId;
        data["wizardId"] = this.wizardId;
        data["quickCreate"] = this.quickCreate;
        data["externalQuestionnaire"] = this.externalQuestionnaire;
        data["searchInWizard"] = this.searchInWizard;
        return data;
    }
}

export interface IGetRegardingObjectTypeResponse {
    id: string;
    code: number;
    pluralName: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    language: string | undefined;
    platormEntity: boolean;
    type: boolean;
    name: string | undefined;
    attachment: boolean;
    wizard: boolean;
    task: boolean;
    showInMenu: boolean;
    publish: boolean;
    organizationId: string | undefined;
    wizardId: string | undefined;
    quickCreate: boolean;
    externalQuestionnaire: boolean;
    searchInWizard: boolean;
}

export class GetReportTemplateResponse implements IGetReportTemplateResponse {
    id!: string;
    name!: string | undefined;
    description!: string | undefined;
    language!: string | undefined;
    wizardId!: string | undefined;
    organizationId!: string | undefined;

    constructor(data?: IGetReportTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.language = _data["language"];
            this.wizardId = _data["wizardId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): GetReportTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["language"] = this.language;
        data["wizardId"] = this.wizardId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IGetReportTemplateResponse {
    id: string;
    name: string | undefined;
    description: string | undefined;
    language: string | undefined;
    wizardId: string | undefined;
    organizationId: string | undefined;
}

export class GetRoleResponse implements IGetRoleResponse {
    id!: string;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IGetRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetRoleResponse {
    id: string;
    name: string | undefined;
    description: string | undefined;
}

export class GetSectionProcessResponse implements IGetSectionProcessResponse {
    id!: string;
    sectionName!: string | undefined;
    reportName!: string | undefined;
    approvalRequest!: boolean;
    escalationRequest!: boolean;
    lastUpdated!: dayjs.Dayjs;
    regardingObjectTypeId!: string;
    nameShort!: string | undefined;
    descriptionShort!: string | undefined;
    flowEngine!: boolean;
    lock!: boolean;
    attachmentExists!: boolean;
    readonly state!: string | undefined;
    name!: string | undefined;
    sectionId!: string;
    wizardId!: string;
    responsibleId!: string | undefined;
    order!: number;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IGetSectionProcessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionName = _data["sectionName"];
            this.reportName = _data["reportName"];
            this.approvalRequest = _data["approvalRequest"];
            this.escalationRequest = _data["escalationRequest"];
            this.lastUpdated = _data["lastUpdated"] ? dayjs(_data["lastUpdated"].toString()) : <any>undefined;
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.nameShort = _data["nameShort"];
            this.descriptionShort = _data["descriptionShort"];
            this.flowEngine = _data["flowEngine"];
            this.lock = _data["lock"];
            this.attachmentExists = _data["attachmentExists"];
            (<any>this).state = _data["state"];
            this.name = _data["name"];
            this.sectionId = _data["sectionId"];
            this.wizardId = _data["wizardId"];
            this.responsibleId = _data["responsibleId"];
            this.order = _data["order"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSectionProcessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSectionProcessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionName"] = this.sectionName;
        data["reportName"] = this.reportName;
        data["approvalRequest"] = this.approvalRequest;
        data["escalationRequest"] = this.escalationRequest;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["nameShort"] = this.nameShort;
        data["descriptionShort"] = this.descriptionShort;
        data["flowEngine"] = this.flowEngine;
        data["lock"] = this.lock;
        data["attachmentExists"] = this.attachmentExists;
        data["state"] = this.state;
        data["name"] = this.name;
        data["sectionId"] = this.sectionId;
        data["wizardId"] = this.wizardId;
        data["responsibleId"] = this.responsibleId;
        data["order"] = this.order;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSectionProcessResponse {
    id: string;
    sectionName: string | undefined;
    reportName: string | undefined;
    approvalRequest: boolean;
    escalationRequest: boolean;
    lastUpdated: dayjs.Dayjs;
    regardingObjectTypeId: string;
    nameShort: string | undefined;
    descriptionShort: string | undefined;
    flowEngine: boolean;
    lock: boolean;
    attachmentExists: boolean;
    state: string | undefined;
    name: string | undefined;
    sectionId: string;
    wizardId: string;
    responsibleId: string | undefined;
    order: number;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class GetSectionResponse implements IGetSectionResponse {
    organizationId!: string;
    id!: string;
    regardingObjectTypeId!: string;
    name!: string;
    icon!: string | undefined;
    order!: number;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IGetSectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.id = _data["id"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.order = _data["order"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["id"] = this.id;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["order"] = this.order;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSectionResponse {
    organizationId: string;
    id: string;
    regardingObjectTypeId: string;
    name: string;
    icon: string | undefined;
    order: number;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class GetSectionTranslationResponse implements IGetSectionTranslationResponse {
    id!: string;
    sectionId!: string;
    nameShort!: string | undefined;
    descriptionShort!: string | undefined;
    language!: string | undefined;

    constructor(data?: IGetSectionTranslationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionId = _data["sectionId"];
            this.nameShort = _data["nameShort"];
            this.descriptionShort = _data["descriptionShort"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): GetSectionTranslationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSectionTranslationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionId"] = this.sectionId;
        data["nameShort"] = this.nameShort;
        data["descriptionShort"] = this.descriptionShort;
        data["language"] = this.language;
        return data;
    }
}

export interface IGetSectionTranslationResponse {
    id: string;
    sectionId: string;
    nameShort: string | undefined;
    descriptionShort: string | undefined;
    language: string | undefined;
}

export class GetSystemsResponse implements IGetSystemsResponse {
    id!: string;
    name!: string;
    url!: string;
    publisher!: string | undefined;
    description!: string | undefined;
    welcomeMailId!: number;
    settings!: string | undefined;
    interWizardPageLevel!: boolean;
    interWizardPanelLevel!: boolean;
    interWizardQuestionLevel!: boolean;

    constructor(data?: IGetSystemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.publisher = _data["publisher"];
            this.description = _data["description"];
            this.welcomeMailId = _data["welcomeMailId"];
            this.settings = _data["settings"];
            this.interWizardPageLevel = _data["interWizardPageLevel"];
            this.interWizardPanelLevel = _data["interWizardPanelLevel"];
            this.interWizardQuestionLevel = _data["interWizardQuestionLevel"];
        }
    }

    static fromJS(data: any): GetSystemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSystemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["publisher"] = this.publisher;
        data["description"] = this.description;
        data["welcomeMailId"] = this.welcomeMailId;
        data["settings"] = this.settings;
        data["interWizardPageLevel"] = this.interWizardPageLevel;
        data["interWizardPanelLevel"] = this.interWizardPanelLevel;
        data["interWizardQuestionLevel"] = this.interWizardQuestionLevel;
        return data;
    }
}

export interface IGetSystemsResponse {
    id: string;
    name: string;
    url: string;
    publisher: string | undefined;
    description: string | undefined;
    welcomeMailId: number;
    settings: string | undefined;
    interWizardPageLevel: boolean;
    interWizardPanelLevel: boolean;
    interWizardQuestionLevel: boolean;
}

export class GetTasksResponse implements IGetTasksResponse {
    id!: string;
    users!: GetUserResponse[] | undefined;
    seriesId!: string;
    actualDueDate!: dayjs.Dayjs;
    actualEndDate!: dayjs.Dayjs;
    entityTypeName!: string | undefined;
    entityName!: string | undefined;
    statusCode!: number;
    status!: string | undefined;
    recurrenceType!: string | undefined;
    taskRegardingObjectTypeId!: string;
    name!: string | undefined;
    dueTime!: string;
    endDate!: dayjs.Dayjs;
    dueDate!: dayjs.Dayjs;
    dayOfWeek!: number | undefined;
    dayOfMonth!: number | undefined;
    monthOfYear!: number | undefined;
    description!: string | undefined;
    regardingObjectId!: string | undefined;
    regardingObjectTypeId!: string | undefined;
    recurrenceTypeId!: string;
    progression!: string | undefined;
    progressPercentage!: number | undefined;
    approvalFlowId!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IGetTasksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(GetUserResponse.fromJS(item));
            }
            this.seriesId = _data["seriesId"];
            this.actualDueDate = _data["actualDueDate"] ? dayjs(_data["actualDueDate"].toString()) : <any>undefined;
            this.actualEndDate = _data["actualEndDate"] ? dayjs(_data["actualEndDate"].toString()) : <any>undefined;
            this.entityTypeName = _data["entityTypeName"];
            this.entityName = _data["entityName"];
            this.statusCode = _data["statusCode"];
            this.status = _data["status"];
            this.recurrenceType = _data["recurrenceType"];
            this.taskRegardingObjectTypeId = _data["taskRegardingObjectTypeId"];
            this.name = _data["name"];
            this.dueTime = _data["dueTime"];
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? dayjs(_data["dueDate"].toString()) : <any>undefined;
            this.dayOfWeek = _data["dayOfWeek"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.monthOfYear = _data["monthOfYear"];
            this.description = _data["description"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.progression = _data["progression"];
            this.progressPercentage = _data["progressPercentage"];
            this.approvalFlowId = _data["approvalFlowId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTasksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["seriesId"] = this.seriesId;
        data["actualDueDate"] = this.actualDueDate ? this.actualDueDate.toISOString() : <any>undefined;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : <any>undefined;
        data["entityTypeName"] = this.entityTypeName;
        data["entityName"] = this.entityName;
        data["statusCode"] = this.statusCode;
        data["status"] = this.status;
        data["recurrenceType"] = this.recurrenceType;
        data["taskRegardingObjectTypeId"] = this.taskRegardingObjectTypeId;
        data["name"] = this.name;
        data["dueTime"] = this.dueTime;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dayOfWeek"] = this.dayOfWeek;
        data["dayOfMonth"] = this.dayOfMonth;
        data["monthOfYear"] = this.monthOfYear;
        data["description"] = this.description;
        data["regardingObjectId"] = this.regardingObjectId;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["progression"] = this.progression;
        data["progressPercentage"] = this.progressPercentage;
        data["approvalFlowId"] = this.approvalFlowId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTasksResponse {
    id: string;
    users: GetUserResponse[] | undefined;
    seriesId: string;
    actualDueDate: dayjs.Dayjs;
    actualEndDate: dayjs.Dayjs;
    entityTypeName: string | undefined;
    entityName: string | undefined;
    statusCode: number;
    status: string | undefined;
    recurrenceType: string | undefined;
    taskRegardingObjectTypeId: string;
    name: string | undefined;
    dueTime: string;
    endDate: dayjs.Dayjs;
    dueDate: dayjs.Dayjs;
    dayOfWeek: number | undefined;
    dayOfMonth: number | undefined;
    monthOfYear: number | undefined;
    description: string | undefined;
    regardingObjectId: string | undefined;
    regardingObjectTypeId: string | undefined;
    recurrenceTypeId: string;
    progression: string | undefined;
    progressPercentage: number | undefined;
    approvalFlowId: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class GetTasksResponsePagedList implements IGetTasksResponsePagedList {
    list!: GetTasksResponse[] | undefined;
    paging!: Paging;

    constructor(data?: IGetTasksResponsePagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(GetTasksResponse.fromJS(item));
            }
            this.paging = _data["paging"] ? Paging.fromJS(_data["paging"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTasksResponsePagedList {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksResponsePagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["paging"] = this.paging ? this.paging.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTasksResponsePagedList {
    list: GetTasksResponse[] | undefined;
    paging: Paging;
}

export class GetTasksResponseV2 implements IGetTasksResponseV2 {
    id!: string;
    users!: GetUserResponse[] | undefined;
    seriesId!: string;
    actualDueDate!: dayjs.Dayjs;
    actualEndDate!: dayjs.Dayjs;
    entityTypeName!: string | undefined;
    entityName!: string | undefined;
    statusCode!: number;
    status!: string | undefined;
    recurrenceType!: string | undefined;
    taskRegardingObjectTypeId!: string;
    taskEntityTypeAndName!: TaskEntityTypeAndName[] | undefined;
    name!: string | undefined;
    dueTime!: string;
    endDate!: dayjs.Dayjs;
    dueDate!: dayjs.Dayjs;
    dayOfWeek!: number | undefined;
    dayOfMonth!: number | undefined;
    monthOfYear!: number | undefined;
    description!: string | undefined;
    regardingObjectId!: string | undefined;
    regardingObjectTypeId!: string | undefined;
    recurrenceTypeId!: string;
    progression!: string | undefined;
    progressPercentage!: number | undefined;
    approvalFlowId!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IGetTasksResponseV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(GetUserResponse.fromJS(item));
            }
            this.seriesId = _data["seriesId"];
            this.actualDueDate = _data["actualDueDate"] ? dayjs(_data["actualDueDate"].toString()) : <any>undefined;
            this.actualEndDate = _data["actualEndDate"] ? dayjs(_data["actualEndDate"].toString()) : <any>undefined;
            this.entityTypeName = _data["entityTypeName"];
            this.entityName = _data["entityName"];
            this.statusCode = _data["statusCode"];
            this.status = _data["status"];
            this.recurrenceType = _data["recurrenceType"];
            this.taskRegardingObjectTypeId = _data["taskRegardingObjectTypeId"];
            if (Array.isArray(_data["taskEntityTypeAndName"])) {
                this.taskEntityTypeAndName = [] as any;
                for (let item of _data["taskEntityTypeAndName"])
                    this.taskEntityTypeAndName!.push(TaskEntityTypeAndName.fromJS(item));
            }
            this.name = _data["name"];
            this.dueTime = _data["dueTime"];
            this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? dayjs(_data["dueDate"].toString()) : <any>undefined;
            this.dayOfWeek = _data["dayOfWeek"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.monthOfYear = _data["monthOfYear"];
            this.description = _data["description"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.recurrenceTypeId = _data["recurrenceTypeId"];
            this.progression = _data["progression"];
            this.progressPercentage = _data["progressPercentage"];
            this.approvalFlowId = _data["approvalFlowId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTasksResponseV2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetTasksResponseV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["seriesId"] = this.seriesId;
        data["actualDueDate"] = this.actualDueDate ? this.actualDueDate.toISOString() : <any>undefined;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : <any>undefined;
        data["entityTypeName"] = this.entityTypeName;
        data["entityName"] = this.entityName;
        data["statusCode"] = this.statusCode;
        data["status"] = this.status;
        data["recurrenceType"] = this.recurrenceType;
        data["taskRegardingObjectTypeId"] = this.taskRegardingObjectTypeId;
        if (Array.isArray(this.taskEntityTypeAndName)) {
            data["taskEntityTypeAndName"] = [];
            for (let item of this.taskEntityTypeAndName)
                data["taskEntityTypeAndName"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["dueTime"] = this.dueTime;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dayOfWeek"] = this.dayOfWeek;
        data["dayOfMonth"] = this.dayOfMonth;
        data["monthOfYear"] = this.monthOfYear;
        data["description"] = this.description;
        data["regardingObjectId"] = this.regardingObjectId;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["recurrenceTypeId"] = this.recurrenceTypeId;
        data["progression"] = this.progression;
        data["progressPercentage"] = this.progressPercentage;
        data["approvalFlowId"] = this.approvalFlowId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTasksResponseV2 {
    id: string;
    users: GetUserResponse[] | undefined;
    seriesId: string;
    actualDueDate: dayjs.Dayjs;
    actualEndDate: dayjs.Dayjs;
    entityTypeName: string | undefined;
    entityName: string | undefined;
    statusCode: number;
    status: string | undefined;
    recurrenceType: string | undefined;
    taskRegardingObjectTypeId: string;
    taskEntityTypeAndName: TaskEntityTypeAndName[] | undefined;
    name: string | undefined;
    dueTime: string;
    endDate: dayjs.Dayjs;
    dueDate: dayjs.Dayjs;
    dayOfWeek: number | undefined;
    dayOfMonth: number | undefined;
    monthOfYear: number | undefined;
    description: string | undefined;
    regardingObjectId: string | undefined;
    regardingObjectTypeId: string | undefined;
    recurrenceTypeId: string;
    progression: string | undefined;
    progressPercentage: number | undefined;
    approvalFlowId: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class GetTeamResponse implements IGetTeamResponse {
    id!: string;
    name!: string | undefined;
    description!: string | undefined;
    email!: string | undefined;

    constructor(data?: IGetTeamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GetTeamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTeamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["email"] = this.email;
        return data;
    }
}

export interface IGetTeamResponse {
    id: string;
    name: string | undefined;
    description: string | undefined;
    email: string | undefined;
}

export class GetUserDefaultOrganizationResponse implements IGetUserDefaultOrganizationResponse {
    organizationId!: string;
    b2CId!: string;
    userId!: string;
    userEmail!: string | undefined;
    defaultLanguage!: string | undefined;
    isDefault!: boolean;
    isFavorite!: boolean;
    claims!: UserClaimDto[] | undefined;
    accountLevel!: AccountLevel;
    readonly system!: string | undefined;
    readonly systemSettings!: SystemSettings;
    landOnDashboard!: boolean;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: IGetUserDefaultOrganizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.b2CId = _data["b2CId"];
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.isDefault = _data["isDefault"];
            this.isFavorite = _data["isFavorite"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaimDto.fromJS(item));
            }
            this.accountLevel = _data["accountLevel"];
            (<any>this).system = _data["system"];
            (<any>this).systemSettings = JSON.parse(_data["systemSettings"]);
            this.landOnDashboard = _data["landOnDashboard"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): GetUserDefaultOrganizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserDefaultOrganizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["b2CId"] = this.b2CId;
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        data["defaultLanguage"] = this.defaultLanguage;
        data["isDefault"] = this.isDefault;
        data["isFavorite"] = this.isFavorite;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["accountLevel"] = this.accountLevel;
        data["system"] = this.system;
        data["systemSettings"] = this.systemSettings;
        data["landOnDashboard"] = this.landOnDashboard;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface IGetUserDefaultOrganizationResponse {
    organizationId: string;
    b2CId: string;
    userId: string;
    userEmail: string | undefined;
    defaultLanguage: string | undefined;
    isDefault: boolean;
    isFavorite: boolean;
    claims: UserClaimDto[] | undefined;
    accountLevel: AccountLevel;
    system: string | undefined;
    systemSettings: SystemSettings;
    landOnDashboard: boolean;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class GetUserDetailResponse implements IGetUserDetailResponse {
    id!: string;
    b2CId!: string;
    profileImage!: string | undefined;
    profileImageName!: string | undefined;
    organizations!: Organization[] | undefined;
    externalProviders!: ExternalProvider[] | undefined;
    profileImageContentType!: string | undefined;
    readonly landOnDashboard!: boolean;
    name!: string;
    organizationId!: string;
    phone!: string | undefined;
    email!: string | undefined;
    file!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IGetUserDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.b2CId = _data["b2CId"];
            this.profileImage = _data["profileImage"];
            this.profileImageName = _data["profileImageName"];
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(Organization.fromJS(item));
            }
            if (Array.isArray(_data["externalProviders"])) {
                this.externalProviders = [] as any;
                for (let item of _data["externalProviders"])
                    this.externalProviders!.push(ExternalProvider.fromJS(item));
            }
            this.profileImageContentType = _data["profileImageContentType"];
            (<any>this).landOnDashboard = _data["landOnDashboard"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.file = _data["file"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["b2CId"] = this.b2CId;
        data["profileImage"] = this.profileImage;
        data["profileImageName"] = this.profileImageName;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.externalProviders)) {
            data["externalProviders"] = [];
            for (let item of this.externalProviders)
                data["externalProviders"].push(item.toJSON());
        }
        data["profileImageContentType"] = this.profileImageContentType;
        data["landOnDashboard"] = this.landOnDashboard;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["file"] = this.file;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserDetailResponse {
    id: string;
    b2CId: string;
    profileImage: string | undefined;
    profileImageName: string | undefined;
    organizations: Organization[] | undefined;
    externalProviders: ExternalProvider[] | undefined;
    profileImageContentType: string | undefined;
    landOnDashboard: boolean;
    name: string;
    organizationId: string;
    phone: string | undefined;
    email: string | undefined;
    file: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class GetUserOrganizationsResponse implements IGetUserOrganizationsResponse {
    organizations!: UserOrganization[] | undefined;

    constructor(data?: IGetUserOrganizationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(UserOrganization.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserOrganizationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOrganizationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserOrganizationsResponse {
    organizations: UserOrganization[] | undefined;
}

export class GetUserResponse implements IGetUserResponse {
    id!: string;
    b2CId!: string;
    organizationName!: string | undefined;
    regardingObjectTypeId!: string;
    roles!: GetRoleResponse[] | undefined;
    profileImage!: string | undefined;
    profileImageName!: string | undefined;
    userId!: string;
    landOnDashboard!: boolean;
    userType!: string | undefined;
    name!: string;
    organizationId!: string;
    phone!: string | undefined;
    email!: string | undefined;
    file!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IGetUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.b2CId = _data["b2CId"];
            this.organizationName = _data["organizationName"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(GetRoleResponse.fromJS(item));
            }
            this.profileImage = _data["profileImage"];
            this.profileImageName = _data["profileImageName"];
            this.userId = _data["userId"];
            this.landOnDashboard = _data["landOnDashboard"];
            this.userType = _data["userType"];
            this.name = _data["name"];
            this.organizationId = _data["organizationId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.file = _data["file"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["b2CId"] = this.b2CId;
        data["organizationName"] = this.organizationName;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["profileImage"] = this.profileImage;
        data["profileImageName"] = this.profileImageName;
        data["userId"] = this.userId;
        data["landOnDashboard"] = this.landOnDashboard;
        data["userType"] = this.userType;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["file"] = this.file;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserResponse {
    id: string;
    b2CId: string;
    organizationName: string | undefined;
    regardingObjectTypeId: string;
    roles: GetRoleResponse[] | undefined;
    profileImage: string | undefined;
    profileImageName: string | undefined;
    userId: string;
    landOnDashboard: boolean;
    userType: string | undefined;
    name: string;
    organizationId: string;
    phone: string | undefined;
    email: string | undefined;
    file: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class IActionResult implements IIActionResult {

    constructor(data?: IIActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new IActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIActionResult {
}

export class MatrixRow implements IMatrixRow {
    readonly value!: string | undefined;
    readonly text!: string | undefined;

    constructor(data?: IMatrixRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).value = _data["value"];
            (<any>this).text = _data["text"];
        }
    }

    static fromJS(data: any): MatrixRow {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        return data;
    }
}

export interface IMatrixRow {
    value: string | undefined;
    text: string | undefined;
}

export class MemoryStream implements IMemoryStream {
    readonly canRead!: boolean;
    readonly canSeek!: boolean;
    readonly canWrite!: boolean;
    capacity!: number;
    readonly length!: number;
    position!: number;
    readonly canTimeout!: boolean;
    readTimeout!: number;
    writeTimeout!: number;

    constructor(data?: IMemoryStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canWrite = _data["canWrite"];
            this.capacity = _data["capacity"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            (<any>this).canTimeout = _data["canTimeout"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): MemoryStream {
        data = typeof data === 'object' ? data : {};
        let result = new MemoryStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canWrite"] = this.canWrite;
        data["capacity"] = this.capacity;
        data["length"] = this.length;
        data["position"] = this.position;
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data;
    }
}

export interface IMemoryStream {
    canRead: boolean;
    canSeek: boolean;
    canWrite: boolean;
    capacity: number;
    length: number;
    position: number;
    canTimeout: boolean;
    readTimeout: number;
    writeTimeout: number;
}

export class Option implements IOption {
    id!: string;
    value!: string | undefined;
    label!: string | undefined;

    constructor(data?: IOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): Option {
        data = typeof data === 'object' ? data : {};
        let result = new Option();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IOption {
    id: string;
    value: string | undefined;
    label: string | undefined;
}

export class Organization implements IOrganization {
    organizationId!: string;
    organizationType!: string | undefined;
    organizationName!: string | undefined;
    isActive!: boolean;
    isDefault!: boolean;
    isFavourite!: boolean;
    favouritePartner!: boolean;

    constructor(data?: IOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationType = _data["organizationType"];
            this.organizationName = _data["organizationName"];
            this.isActive = _data["isActive"];
            this.isDefault = _data["isDefault"];
            this.isFavourite = _data["isFavourite"];
            this.favouritePartner = _data["favouritePartner"];
        }
    }

    static fromJS(data: any): Organization {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationType"] = this.organizationType;
        data["organizationName"] = this.organizationName;
        data["isActive"] = this.isActive;
        data["isDefault"] = this.isDefault;
        data["isFavourite"] = this.isFavourite;
        data["favouritePartner"] = this.favouritePartner;
        return data;
    }
}

export interface IOrganization {
    organizationId: string;
    organizationType: string | undefined;
    organizationName: string | undefined;
    isActive: boolean;
    isDefault: boolean;
    isFavourite: boolean;
    favouritePartner: boolean;
}

export class OrganizationSystems implements IOrganizationSystems {
    id!: string;
    name!: string | undefined;

    constructor(data?: IOrganizationSystems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrganizationSystems {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationSystems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IOrganizationSystems {
    id: string;
    name: string | undefined;
}

export class Pages implements IPages {
    id!: string;
    type!: string | undefined;
    title!: string | undefined;
    description!: string | undefined;
    condition!: string | undefined;
    order!: number;
    wizardId!: string;
    visibleIf!: string | undefined;
    elements!: Element[] | undefined;

    constructor(data?: IPages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.condition = _data["condition"];
            this.order = _data["order"];
            this.wizardId = _data["wizardId"];
            this.visibleIf = _data["visibleIf"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(Element.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Pages {
        data = typeof data === 'object' ? data : {};
        let result = new Pages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["description"] = this.description;
        data["condition"] = this.condition;
        data["order"] = this.order;
        data["wizardId"] = this.wizardId;
        data["visibleIf"] = this.visibleIf;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPages {
    id: string;
    type: string | undefined;
    title: string | undefined;
    description: string | undefined;
    condition: string | undefined;
    order: number;
    wizardId: string;
    visibleIf: string | undefined;
    elements: Element[] | undefined;
}

export class Paging implements IPaging {
    total!: number;
    limit!: number;
    offset!: number;
    returned!: number;

    constructor(data?: IPaging) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.returned = _data["returned"];
        }
    }

    static fromJS(data: any): Paging {
        data = typeof data === 'object' ? data : {};
        let result = new Paging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["returned"] = this.returned;
        return data;
    }
}

export interface IPaging {
    total: number;
    limit: number;
    offset: number;
    returned: number;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
}

export class Process implements IProcess {
    children!: ProcessQuestion[] | undefined;
    regardingObjectTypeId!: string;
    flowEngine!: boolean;
    lock!: boolean;
    readonly validated!: dayjs.Dayjs | undefined;
    id!: string;
    name!: string | undefined;
    processingRecordId!: string | undefined;
    parentId!: string | undefined;
    type!: string | undefined;
    state!: string | undefined;
    description!: string | undefined;
    icon!: string | undefined;
    size!: number | undefined;
    accessLevel!: number | undefined;
    reportProcessingRecordId!: string | undefined;
    tags!: string[] | undefined;

    constructor(data?: IProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ProcessQuestion.fromJS(item));
            }
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.flowEngine = _data["flowEngine"];
            this.lock = _data["lock"];
            (<any>this).validated = _data["validated"] ? dayjs(_data["validated"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.name = _data["name"];
            this.processingRecordId = _data["processingRecordId"];
            this.parentId = _data["parentId"];
            this.type = _data["type"];
            this.state = _data["state"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.size = _data["size"];
            this.accessLevel = _data["accessLevel"];
            this.reportProcessingRecordId = _data["reportProcessingRecordId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): Process {
        data = typeof data === 'object' ? data : {};
        let result = new Process();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["flowEngine"] = this.flowEngine;
        data["lock"] = this.lock;
        data["validated"] = this.validated ? this.validated.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["processingRecordId"] = this.processingRecordId;
        data["parentId"] = this.parentId;
        data["type"] = this.type;
        data["state"] = this.state;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["size"] = this.size;
        data["accessLevel"] = this.accessLevel;
        data["reportProcessingRecordId"] = this.reportProcessingRecordId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IProcess {
    children: ProcessQuestion[] | undefined;
    regardingObjectTypeId: string;
    flowEngine: boolean;
    lock: boolean;
    validated: dayjs.Dayjs | undefined;
    id: string;
    name: string | undefined;
    processingRecordId: string | undefined;
    parentId: string | undefined;
    type: string | undefined;
    state: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    size: number | undefined;
    accessLevel: number | undefined;
    reportProcessingRecordId: string | undefined;
    tags: string[] | undefined;
}

export class ProcessModel implements IProcessModel {
    id!: string;
    name!: string | undefined;
    impact!: number;
    probability!: number;
    combinedAssessment!: number;
    wizardId!: string;
    readonly regardingObjectTypeId!: string;

    constructor(data?: IProcessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.impact = _data["impact"];
            this.probability = _data["probability"];
            this.combinedAssessment = _data["combinedAssessment"];
            this.wizardId = _data["wizardId"];
            (<any>this).regardingObjectTypeId = _data["regardingObjectTypeId"];
        }
    }

    static fromJS(data: any): ProcessModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["impact"] = this.impact;
        data["probability"] = this.probability;
        data["combinedAssessment"] = this.combinedAssessment;
        data["wizardId"] = this.wizardId;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        return data;
    }
}

export interface IProcessModel {
    id: string;
    name: string | undefined;
    impact: number;
    probability: number;
    combinedAssessment: number;
    wizardId: string;
    regardingObjectTypeId: string;
}

export class ProcessQuestion implements IProcessQuestion {
    id!: string;
    name!: string | undefined;
    processingRecordId!: string | undefined;
    parentId!: string | undefined;
    type!: string | undefined;
    state!: string | undefined;
    description!: string | undefined;
    icon!: string | undefined;
    size!: number | undefined;
    accessLevel!: number | undefined;
    reportProcessingRecordId!: string | undefined;
    tags!: string[] | undefined;

    constructor(data?: IProcessQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.processingRecordId = _data["processingRecordId"];
            this.parentId = _data["parentId"];
            this.type = _data["type"];
            this.state = _data["state"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.size = _data["size"];
            this.accessLevel = _data["accessLevel"];
            this.reportProcessingRecordId = _data["reportProcessingRecordId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["processingRecordId"] = this.processingRecordId;
        data["parentId"] = this.parentId;
        data["type"] = this.type;
        data["state"] = this.state;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["size"] = this.size;
        data["accessLevel"] = this.accessLevel;
        data["reportProcessingRecordId"] = this.reportProcessingRecordId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IProcessQuestion {
    id: string;
    name: string | undefined;
    processingRecordId: string | undefined;
    parentId: string | undefined;
    type: string | undefined;
    state: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    size: number | undefined;
    accessLevel: number | undefined;
    reportProcessingRecordId: string | undefined;
    tags: string[] | undefined;
}

export class Question implements IQuestion {
    questionId!: string;
    type!: string | undefined;
    inputType!: string | undefined;
    name!: string | undefined;
    order!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    descriptionLong!: string | undefined;
    visibleIf!: string | undefined;
    addRowText!: string | undefined;
    horizontalScroll!: boolean;
    columnMinWidth!: string | undefined;
    columnColCount!: number;
    minRowCount!: number;
    maxRowCount!: number;
    rowCount!: number;
    cellType!: string | undefined;
    answerDisplayTypeCode!: number;
    choices!: AnswerOptionSetValues[] | undefined;
    rateValues!: AnswerOptionSetValues[] | undefined;
    columns!: Column[] | undefined;
    rows!: MatrixRow[] | undefined;
    defaultRowValue!: DefaultRowValue;
    expression!: string | undefined;
    isRequired!: boolean;
    options!: Option[] | undefined;
    validators!: Validator[] | undefined;
    optionsByUrl!: string | undefined;
    isMulti!: boolean;
    valueKey!: string | undefined;
    titleKey!: string | undefined;
    isExternalURL!: boolean;
    answerTypeCode!: number;
    defaultValue!: string | undefined;
    readOnly!: boolean;
    referenceDisplayText!: string | undefined;
    reference!: string | undefined;
    visible!: boolean;
    removeRowText!: string | undefined;
    storeDataAsText!: boolean;
    showPreview!: boolean;
    imageWidth!: number;
    maxSize!: number;
    readonly titleLocation!: string | undefined;
    readonly showHeader!: boolean;
    readonly rowTitleWidth!: string | undefined;
    readonly allowMultiple!: boolean;
    acceptedTypes!: string | undefined;
    waitForUpload!: boolean;
    html!: string | undefined;

    constructor(data?: IQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.type = _data["type"];
            this.inputType = _data["inputType"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.descriptionLong = _data["descriptionLong"];
            this.visibleIf = _data["visibleIf"];
            this.addRowText = _data["addRowText"];
            this.horizontalScroll = _data["horizontalScroll"];
            this.columnMinWidth = _data["columnMinWidth"];
            this.columnColCount = _data["columnColCount"];
            this.minRowCount = _data["minRowCount"];
            this.maxRowCount = _data["maxRowCount"];
            this.rowCount = _data["rowCount"];
            this.cellType = _data["cellType"];
            this.answerDisplayTypeCode = _data["answerDisplayTypeCode"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(AnswerOptionSetValues.fromJS(item));
            }
            if (Array.isArray(_data["rateValues"])) {
                this.rateValues = [] as any;
                for (let item of _data["rateValues"])
                    this.rateValues!.push(AnswerOptionSetValues.fromJS(item));
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(Column.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MatrixRow.fromJS(item));
            }
            this.defaultRowValue = _data["defaultRowValue"] ? DefaultRowValue.fromJS(_data["defaultRowValue"]) : <any>undefined;
            this.expression = _data["expression"];
            this.isRequired = _data["isRequired"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(Option.fromJS(item));
            }
            if (Array.isArray(_data["validators"])) {
                this.validators = [] as any;
                for (let item of _data["validators"])
                    this.validators!.push(Validator.fromJS(item));
            }
            this.optionsByUrl = _data["optionsByUrl"];
            this.isMulti = _data["isMulti"];
            this.valueKey = _data["valueKey"];
            this.titleKey = _data["titleKey"];
            this.isExternalURL = _data["isExternalURL"];
            this.answerTypeCode = _data["answerTypeCode"];
            this.defaultValue = _data["defaultValue"];
            this.readOnly = _data["readOnly"];
            this.referenceDisplayText = _data["referenceDisplayText"];
            this.reference = _data["reference"];
            this.visible = _data["visible"];
            this.removeRowText = _data["removeRowText"];
            this.storeDataAsText = _data["storeDataAsText"];
            this.showPreview = _data["showPreview"];
            this.imageWidth = _data["imageWidth"];
            this.maxSize = _data["maxSize"];
            (<any>this).titleLocation = _data["titleLocation"];
            (<any>this).showHeader = _data["showHeader"];
            (<any>this).rowTitleWidth = _data["rowTitleWidth"];
            (<any>this).allowMultiple = _data["allowMultiple"];
            this.acceptedTypes = _data["acceptedTypes"];
            this.waitForUpload = _data["waitForUpload"];
            this.html = _data["html"];
        }
    }

    static fromJS(data: any): Question {
        data = typeof data === 'object' ? data : {};
        let result = new Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["type"] = this.type;
        data["inputType"] = this.inputType;
        data["name"] = this.name;
        data["order"] = this.order;
        data["title"] = this.title;
        data["description"] = this.description;
        data["descriptionLong"] = this.descriptionLong;
        data["visibleIf"] = this.visibleIf;
        data["addRowText"] = this.addRowText;
        data["horizontalScroll"] = this.horizontalScroll;
        data["columnMinWidth"] = this.columnMinWidth;
        data["columnColCount"] = this.columnColCount;
        data["minRowCount"] = this.minRowCount;
        data["maxRowCount"] = this.maxRowCount;
        data["rowCount"] = this.rowCount;
        data["cellType"] = this.cellType;
        data["answerDisplayTypeCode"] = this.answerDisplayTypeCode;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        if (Array.isArray(this.rateValues)) {
            data["rateValues"] = [];
            for (let item of this.rateValues)
                data["rateValues"].push(item.toJSON());
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["defaultRowValue"] = this.defaultRowValue ? this.defaultRowValue.toJSON() : <any>undefined;
        data["expression"] = this.expression;
        data["isRequired"] = this.isRequired;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (Array.isArray(this.validators)) {
            data["validators"] = [];
            for (let item of this.validators)
                data["validators"].push(item.toJSON());
        }
        data["optionsByUrl"] = this.optionsByUrl;
        data["isMulti"] = this.isMulti;
        data["valueKey"] = this.valueKey;
        data["titleKey"] = this.titleKey;
        data["isExternalURL"] = this.isExternalURL;
        data["answerTypeCode"] = this.answerTypeCode;
        data["defaultValue"] = this.defaultValue;
        data["readOnly"] = this.readOnly;
        data["referenceDisplayText"] = this.referenceDisplayText;
        data["reference"] = this.reference;
        data["visible"] = this.visible;
        data["removeRowText"] = this.removeRowText;
        data["storeDataAsText"] = this.storeDataAsText;
        data["showPreview"] = this.showPreview;
        data["imageWidth"] = this.imageWidth;
        data["maxSize"] = this.maxSize;
        data["titleLocation"] = this.titleLocation;
        data["showHeader"] = this.showHeader;
        data["rowTitleWidth"] = this.rowTitleWidth;
        data["allowMultiple"] = this.allowMultiple;
        data["acceptedTypes"] = this.acceptedTypes;
        data["waitForUpload"] = this.waitForUpload;
        data["html"] = this.html;
        return data;
    }
}

export interface IQuestion {
    questionId: string;
    type: string | undefined;
    inputType: string | undefined;
    name: string | undefined;
    order: number | undefined;
    title: string | undefined;
    description: string | undefined;
    descriptionLong: string | undefined;
    visibleIf: string | undefined;
    addRowText: string | undefined;
    horizontalScroll: boolean;
    columnMinWidth: string | undefined;
    columnColCount: number;
    minRowCount: number;
    maxRowCount: number;
    rowCount: number;
    cellType: string | undefined;
    answerDisplayTypeCode: number;
    choices: AnswerOptionSetValues[] | undefined;
    rateValues: AnswerOptionSetValues[] | undefined;
    columns: Column[] | undefined;
    rows: MatrixRow[] | undefined;
    defaultRowValue: DefaultRowValue;
    expression: string | undefined;
    isRequired: boolean;
    options: Option[] | undefined;
    validators: Validator[] | undefined;
    optionsByUrl: string | undefined;
    isMulti: boolean;
    valueKey: string | undefined;
    titleKey: string | undefined;
    isExternalURL: boolean;
    answerTypeCode: number;
    defaultValue: string | undefined;
    readOnly: boolean;
    referenceDisplayText: string | undefined;
    reference: string | undefined;
    visible: boolean;
    removeRowText: string | undefined;
    storeDataAsText: boolean;
    showPreview: boolean;
    imageWidth: number;
    maxSize: number;
    titleLocation: string | undefined;
    showHeader: boolean;
    rowTitleWidth: string | undefined;
    allowMultiple: boolean;
    acceptedTypes: string | undefined;
    waitForUpload: boolean;
    html: string | undefined;
}

export class QuestionAnswer implements IQuestionAnswer {
    valueId!: string;
    value!: string | undefined;
    label!: string | undefined;

    constructor(data?: IQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueId = _data["valueId"];
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): QuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueId"] = this.valueId;
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IQuestionAnswer {
    valueId: string;
    value: string | undefined;
    label: string | undefined;
}

export class QuestionAnswers implements IQuestionAnswers {
    questionSysId!: string;
    questionId!: string;
    readonly questionSysName!: string | undefined;
    readonly questionDisplayName!: string | undefined;
    value!: string | undefined;
    label!: any | undefined;

    constructor(data?: IQuestionAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionSysId = _data["questionSysId"];
            this.questionId = _data["questionId"];
            (<any>this).questionSysName = _data["questionSysName"];
            (<any>this).questionDisplayName = _data["questionDisplayName"];
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): QuestionAnswers {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionAnswers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionSysId"] = this.questionSysId;
        data["questionId"] = this.questionId;
        data["questionSysName"] = this.questionSysName;
        data["questionDisplayName"] = this.questionDisplayName;
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IQuestionAnswers {
    questionSysId: string;
    questionId: string;
    questionSysName: string | undefined;
    questionDisplayName: string | undefined;
    value: string | undefined;
    label: any | undefined;
}

export class ReportHistoryResponse implements IReportHistoryResponse {
    id!: string;
    createdOn!: dayjs.Dayjs;
    name!: string | undefined;
    contentType!: string | undefined;
    size!: number;
    language!: string | undefined;
    version!: string | undefined;
    type!: string | undefined;

    constructor(data?: IReportHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? dayjs(_data["createdOn"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.contentType = _data["contentType"];
            this.size = _data["size"];
            this.language = _data["language"];
            this.version = _data["version"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ReportHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["language"] = this.language;
        data["version"] = this.version;
        data["type"] = this.type;
        return data;
    }
}

export interface IReportHistoryResponse {
    id: string;
    createdOn: dayjs.Dayjs;
    name: string | undefined;
    contentType: string | undefined;
    size: number;
    language: string | undefined;
    version: string | undefined;
    type: string | undefined;
}

export class ReportJson implements IReportJson {
    name!: string | undefined;
    regardingObjectId!: string;
    lastUpdate!: dayjs.Dayjs;
    responsible!: string | undefined;
    questions!: ReportQuestions[] | undefined;

    constructor(data?: IReportJson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.lastUpdate = _data["lastUpdate"] ? dayjs(_data["lastUpdate"].toString()) : <any>undefined;
            this.responsible = _data["responsible"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(ReportQuestions.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportJson {
        data = typeof data === 'object' ? data : {};
        let result = new ReportJson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["regardingObjectId"] = this.regardingObjectId;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["responsible"] = this.responsible;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportJson {
    name: string | undefined;
    regardingObjectId: string;
    lastUpdate: dayjs.Dayjs;
    responsible: string | undefined;
    questions: ReportQuestions[] | undefined;
}

export class ReportJsonMachine implements IReportJsonMachine {
    name!: string | undefined;
    regardingObjectId!: string;
    lastUpdate!: dayjs.Dayjs;
    responsible!: string | undefined;
    readonly companyName!: string | undefined;
    readonly reportType!: string | undefined;
    readonly wizardId!: string | undefined;
    readonly questions!: any | undefined;
    answers!: QuestionAnswers[] | undefined;
    readonly customFields!: CustomFieldValues[] | undefined;
    readonly state!: string | undefined;

    constructor(data?: IReportJsonMachine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.lastUpdate = _data["lastUpdate"] ? dayjs(_data["lastUpdate"].toString()) : <any>undefined;
            this.responsible = _data["responsible"];
            (<any>this).companyName = _data["companyName"];
            (<any>this).reportType = _data["reportType"];
            (<any>this).wizardId = _data["wizardId"];
            (<any>this).questions = _data["questions"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(QuestionAnswers.fromJS(item));
            }
            if (Array.isArray(_data["customFields"])) {
                (<any>this).customFields = [] as any;
                for (let item of _data["customFields"])
                    (<any>this).customFields!.push(CustomFieldValues.fromJS(item));
            }
            (<any>this).state = _data["state"];
        }
    }

    static fromJS(data: any): ReportJsonMachine {
        data = typeof data === 'object' ? data : {};
        let result = new ReportJsonMachine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["regardingObjectId"] = this.regardingObjectId;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : <any>undefined;
        data["responsible"] = this.responsible;
        data["companyName"] = this.companyName;
        data["reportType"] = this.reportType;
        data["wizardId"] = this.wizardId;
        data["questions"] = this.questions;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        data["state"] = this.state;
        return data;
    }
}

export interface IReportJsonMachine {
    name: string | undefined;
    regardingObjectId: string;
    lastUpdate: dayjs.Dayjs;
    responsible: string | undefined;
    companyName: string | undefined;
    reportType: string | undefined;
    wizardId: string | undefined;
    questions: any | undefined;
    answers: QuestionAnswers[] | undefined;
    customFields: CustomFieldValues[] | undefined;
    state: string | undefined;
}

export class ReportQuestions implements IReportQuestions {
    questionId!: string;
    readonly questionSysName!: string | undefined;
    readonly questionDisplayName!: string | undefined;
    answer!: QuestionAnswer[] | undefined;

    constructor(data?: IReportQuestions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            (<any>this).questionSysName = _data["questionSysName"];
            (<any>this).questionDisplayName = _data["questionDisplayName"];
            if (Array.isArray(_data["answer"])) {
                this.answer = [] as any;
                for (let item of _data["answer"])
                    this.answer!.push(QuestionAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportQuestions {
        data = typeof data === 'object' ? data : {};
        let result = new ReportQuestions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["questionSysName"] = this.questionSysName;
        data["questionDisplayName"] = this.questionDisplayName;
        if (Array.isArray(this.answer)) {
            data["answer"] = [];
            for (let item of this.answer)
                data["answer"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportQuestions {
    questionId: string;
    questionSysName: string | undefined;
    questionDisplayName: string | undefined;
    answer: QuestionAnswer[] | undefined;
}

export class Response implements IResponse {
    message!: string | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IResponse {
    message: string | undefined;
}

export class RiskAssessmentModel implements IRiskAssessmentModel {
    name!: string | undefined;
    criticality!: number;
    vulnerability!: number;
    processes!: ProcessModel[] | undefined;
    value!: number;

    constructor(data?: IRiskAssessmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.criticality = _data["criticality"];
            this.vulnerability = _data["vulnerability"];
            if (Array.isArray(_data["processes"])) {
                this.processes = [] as any;
                for (let item of _data["processes"])
                    this.processes!.push(ProcessModel.fromJS(item));
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RiskAssessmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskAssessmentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["criticality"] = this.criticality;
        data["vulnerability"] = this.vulnerability;
        if (Array.isArray(this.processes)) {
            data["processes"] = [];
            for (let item of this.processes)
                data["processes"].push(item.toJSON());
        }
        data["value"] = this.value;
        return data;
    }
}

export interface IRiskAssessmentModel {
    name: string | undefined;
    criticality: number;
    vulnerability: number;
    processes: ProcessModel[] | undefined;
    value: number;
}

export class RoleClaimAssociationRequest implements IRoleClaimAssociationRequest {
    roleId!: string;
    regardingObjectTyoeId!: string;
    sectionId!: string | undefined;
    action!: ClaimActionType;

    constructor(data?: IRoleClaimAssociationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.regardingObjectTyoeId = _data["regardingObjectTyoeId"];
            this.sectionId = _data["sectionId"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): RoleClaimAssociationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RoleClaimAssociationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["regardingObjectTyoeId"] = this.regardingObjectTyoeId;
        data["sectionId"] = this.sectionId;
        data["action"] = this.action;
        return data;
    }
}

export interface IRoleClaimAssociationRequest {
    roleId: string;
    regardingObjectTyoeId: string;
    sectionId: string | undefined;
    action: ClaimActionType;
}

export class Section implements ISection {
    children!: Process[] | undefined;
    id!: string;
    name!: string | undefined;
    processingRecordId!: string | undefined;
    parentId!: string | undefined;
    type!: string | undefined;
    state!: string | undefined;
    description!: string | undefined;
    icon!: string | undefined;
    size!: number | undefined;
    accessLevel!: number | undefined;
    reportProcessingRecordId!: string | undefined;
    tags!: string[] | undefined;

    constructor(data?: ISection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Process.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.processingRecordId = _data["processingRecordId"];
            this.parentId = _data["parentId"];
            this.type = _data["type"];
            this.state = _data["state"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.size = _data["size"];
            this.accessLevel = _data["accessLevel"];
            this.reportProcessingRecordId = _data["reportProcessingRecordId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): Section {
        data = typeof data === 'object' ? data : {};
        let result = new Section();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["processingRecordId"] = this.processingRecordId;
        data["parentId"] = this.parentId;
        data["type"] = this.type;
        data["state"] = this.state;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["size"] = this.size;
        data["accessLevel"] = this.accessLevel;
        data["reportProcessingRecordId"] = this.reportProcessingRecordId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface ISection {
    children: Process[] | undefined;
    id: string;
    name: string | undefined;
    processingRecordId: string | undefined;
    parentId: string | undefined;
    type: string | undefined;
    state: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    size: number | undefined;
    accessLevel: number | undefined;
    reportProcessingRecordId: string | undefined;
    tags: string[] | undefined;
}

export class Systems implements ISystems {
    name!: string;
    url!: string;
    publisher!: string | undefined;
    description!: string | undefined;
    welcomeMailId!: number;
    settings!: string | undefined;
    interWizardPageLevel!: boolean;
    interWizardPanelLevel!: boolean;
    interWizardQuestionLevel!: boolean;

    constructor(data?: ISystems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.publisher = _data["publisher"];
            this.description = _data["description"];
            this.welcomeMailId = _data["welcomeMailId"];
            this.settings = _data["settings"];
            this.interWizardPageLevel = _data["interWizardPageLevel"];
            this.interWizardPanelLevel = _data["interWizardPanelLevel"];
            this.interWizardQuestionLevel = _data["interWizardQuestionLevel"];
        }
    }

    static fromJS(data: any): Systems {
        data = typeof data === 'object' ? data : {};
        let result = new Systems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["publisher"] = this.publisher;
        data["description"] = this.description;
        data["welcomeMailId"] = this.welcomeMailId;
        data["settings"] = this.settings;
        data["interWizardPageLevel"] = this.interWizardPageLevel;
        data["interWizardPanelLevel"] = this.interWizardPanelLevel;
        data["interWizardQuestionLevel"] = this.interWizardQuestionLevel;
        return data;
    }
}

export interface ISystems {
    name: string;
    url: string;
    publisher: string | undefined;
    description: string | undefined;
    welcomeMailId: number;
    settings: string | undefined;
    interWizardPageLevel: boolean;
    interWizardPanelLevel: boolean;
    interWizardQuestionLevel: boolean;
}

export class TagBoxSelectedValue implements ITagBoxSelectedValue {
    id!: string;
    value!: string | undefined;
    label!: string | undefined;

    constructor(data?: ITagBoxSelectedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): TagBoxSelectedValue {
        data = typeof data === 'object' ? data : {};
        let result = new TagBoxSelectedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface ITagBoxSelectedValue {
    id: string;
    value: string | undefined;
    label: string | undefined;
}

export class TagBoxValue implements ITagBoxValue {
    value!: string | undefined;
    label!: string | undefined;
    description!: string | undefined;

    constructor(data?: ITagBoxValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TagBoxValue {
        data = typeof data === 'object' ? data : {};
        let result = new TagBoxValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        data["description"] = this.description;
        return data;
    }
}

export interface ITagBoxValue {
    value: string | undefined;
    label: string | undefined;
    description: string | undefined;
}

export class TaskEntities implements ITaskEntities {
    regardingObjectId!: string;
    regardingObjectTypeId!: string;
    taskId!: string;

    constructor(data?: ITaskEntities) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regardingObjectId = _data["regardingObjectId"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): TaskEntities {
        data = typeof data === 'object' ? data : {};
        let result = new TaskEntities();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regardingObjectId"] = this.regardingObjectId;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface ITaskEntities {
    regardingObjectId: string;
    regardingObjectTypeId: string;
    taskId: string;
}

export class TaskEntityTypeAndName implements ITaskEntityTypeAndName {
    entityName!: string | undefined;
    regardingObjectId!: string;
    entityType!: string | undefined;
    regardingObjectTypeId!: string;

    constructor(data?: ITaskEntityTypeAndName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityName = _data["entityName"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.entityType = _data["entityType"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
        }
    }

    static fromJS(data: any): TaskEntityTypeAndName {
        data = typeof data === 'object' ? data : {};
        let result = new TaskEntityTypeAndName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName;
        data["regardingObjectId"] = this.regardingObjectId;
        data["entityType"] = this.entityType;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        return data;
    }
}

export interface ITaskEntityTypeAndName {
    entityName: string | undefined;
    regardingObjectId: string;
    entityType: string | undefined;
    regardingObjectTypeId: string;
}

export class TeamUserAssociationRequest implements ITeamUserAssociationRequest {
    teamId!: string;
    userId!: string;
    organizationId!: string;

    constructor(data?: ITeamUserAssociationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.userId = _data["userId"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): TeamUserAssociationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TeamUserAssociationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["userId"] = this.userId;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ITeamUserAssociationRequest {
    teamId: string;
    userId: string;
    organizationId: string;
}

export class TranslateSectionRequest implements ITranslateSectionRequest {
    id!: string;

    constructor(data?: ITranslateSectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TranslateSectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateSectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITranslateSectionRequest {
    id: string;
}

export class TriggerApprovalFlowHistoryRequest implements ITriggerApprovalFlowHistoryRequest {
    regardingObjectTypeId!: string;
    regardingObjectId!: string;
    actionType!: number;

    constructor(data?: ITriggerApprovalFlowHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.actionType = _data["actionType"];
        }
    }

    static fromJS(data: any): TriggerApprovalFlowHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerApprovalFlowHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["regardingObjectId"] = this.regardingObjectId;
        data["actionType"] = this.actionType;
        return data;
    }
}

export interface ITriggerApprovalFlowHistoryRequest {
    regardingObjectTypeId: string;
    regardingObjectId: string;
    actionType: number;
}

export class UpdateCompanyRequest implements IUpdateCompanyRequest {
    id!: string;
    systemIds!: string[] | undefined;
    accountRepresentatives!: string[] | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: IUpdateCompanyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["systemIds"])) {
                this.systemIds = [] as any;
                for (let item of _data["systemIds"])
                    this.systemIds!.push(item);
            }
            if (Array.isArray(_data["accountRepresentatives"])) {
                this.accountRepresentatives = [] as any;
                for (let item of _data["accountRepresentatives"])
                    this.accountRepresentatives!.push(item);
            }
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): UpdateCompanyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.systemIds)) {
            data["systemIds"] = [];
            for (let item of this.systemIds)
                data["systemIds"].push(item);
        }
        if (Array.isArray(this.accountRepresentatives)) {
            data["accountRepresentatives"] = [];
            for (let item of this.accountRepresentatives)
                data["accountRepresentatives"].push(item);
        }
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface IUpdateCompanyRequest {
    id: string;
    systemIds: string[] | undefined;
    accountRepresentatives: string[] | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class UpdateCustomEntityValueRequest implements IUpdateCustomEntityValueRequest {
    id!: string;
    parentId!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    regardingObjectTypeId!: string;
    userId!: string | undefined;
    wizardId!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IUpdateCustomEntityValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.userId = _data["userId"];
            this.wizardId = _data["wizardId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCustomEntityValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomEntityValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["userId"] = this.userId;
        data["wizardId"] = this.wizardId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateCustomEntityValueRequest {
    id: string;
    parentId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    regardingObjectTypeId: string;
    userId: string | undefined;
    wizardId: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class UpdateCustomFieldResponse implements IUpdateCustomFieldResponse {
    id!: string;
    value!: string | undefined;

    constructor(data?: IUpdateCustomFieldResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateCustomFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateCustomFieldResponse {
    id: string;
    value: string | undefined;
}

export class UpdateCustomFieldValueRequest implements IUpdateCustomFieldValueRequest {
    customFieldId!: string;
    regardingObjectId!: string;
    regardingObjectTypeId!: string;
    value!: string | undefined;

    constructor(data?: IUpdateCustomFieldValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customFieldId = _data["customFieldId"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateCustomFieldValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomFieldValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customFieldId"] = this.customFieldId;
        data["regardingObjectId"] = this.regardingObjectId;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateCustomFieldValueRequest {
    customFieldId: string;
    regardingObjectId: string;
    regardingObjectTypeId: string;
    value: string | undefined;
}

export class UpdateMultipleProcessesRequest implements IUpdateMultipleProcessesRequest {
    idList!: string[] | undefined;
    userId!: string;
    name!: string | undefined;
    sectionId!: string;
    wizardId!: string;
    responsibleId!: string | undefined;
    order!: number;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IUpdateMultipleProcessesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["idList"])) {
                this.idList = [] as any;
                for (let item of _data["idList"])
                    this.idList!.push(item);
            }
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.sectionId = _data["sectionId"];
            this.wizardId = _data["wizardId"];
            this.responsibleId = _data["responsibleId"];
            this.order = _data["order"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMultipleProcessesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMultipleProcessesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.idList)) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["sectionId"] = this.sectionId;
        data["wizardId"] = this.wizardId;
        data["responsibleId"] = this.responsibleId;
        data["order"] = this.order;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMultipleProcessesRequest {
    idList: string[] | undefined;
    userId: string;
    name: string | undefined;
    sectionId: string;
    wizardId: string;
    responsibleId: string | undefined;
    order: number;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class UpdatePartnerRequest implements IUpdatePartnerRequest {
    systemIds!: string[];
    id!: string;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: IUpdatePartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.systemIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["systemIds"])) {
                this.systemIds = [] as any;
                for (let item of _data["systemIds"])
                    this.systemIds!.push(item);
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): UpdatePartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemIds)) {
            data["systemIds"] = [];
            for (let item of this.systemIds)
                data["systemIds"].push(item);
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface IUpdatePartnerRequest {
    systemIds: string[];
    id: string;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class UpdateProgressForExternalQuestionnaire implements IUpdateProgressForExternalQuestionnaire {
    partialCompletion!: boolean;
    wizardId!: string;
    recordId!: string;
    regardingObjectTypeId!: string;

    constructor(data?: IUpdateProgressForExternalQuestionnaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partialCompletion = _data["partialCompletion"];
            this.wizardId = _data["wizardId"];
            this.recordId = _data["recordId"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
        }
    }

    static fromJS(data: any): UpdateProgressForExternalQuestionnaire {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProgressForExternalQuestionnaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partialCompletion"] = this.partialCompletion;
        data["wizardId"] = this.wizardId;
        data["recordId"] = this.recordId;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        return data;
    }
}

export interface IUpdateProgressForExternalQuestionnaire {
    partialCompletion: boolean;
    wizardId: string;
    recordId: string;
    regardingObjectTypeId: string;
}

export class UpdateProjectRequest implements IUpdateProjectRequest {
    systemIds!: string[];
    id!: string;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: IUpdateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.systemIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["systemIds"])) {
                this.systemIds = [] as any;
                for (let item of _data["systemIds"])
                    this.systemIds!.push(item);
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): UpdateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemIds)) {
            data["systemIds"] = [];
            for (let item of this.systemIds)
                data["systemIds"].push(item);
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface IUpdateProjectRequest {
    systemIds: string[];
    id: string;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class UpdateQuestionRequest implements IUpdateQuestionRequest {
    id!: string;
    questionCode!: string;
    name!: string | undefined;
    order!: number | undefined;
    condition!: string | undefined;
    answerOptionSetId!: string;
    panelId!: string;
    expression!: string | undefined;
    defaultValue!: string | undefined;
    readOnly!: boolean;
    isRequired!: boolean;
    regardingObjectTypeId!: string | undefined;
    moduleConditions!: string | undefined;
    moduleConditionsV1!: string | undefined;
    relationToWizardConditionOperator!: string | undefined;

    constructor(data?: IUpdateQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionCode = _data["questionCode"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.condition = _data["condition"];
            this.answerOptionSetId = _data["answerOptionSetId"];
            this.panelId = _data["panelId"];
            this.expression = _data["expression"];
            this.defaultValue = _data["defaultValue"];
            this.readOnly = _data["readOnly"];
            this.isRequired = _data["isRequired"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.moduleConditions = _data["moduleConditions"];
            this.moduleConditionsV1 = _data["moduleConditionsV1"];
            this.relationToWizardConditionOperator = _data["relationToWizardConditionOperator"];
        }
    }

    static fromJS(data: any): UpdateQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionCode"] = this.questionCode;
        data["name"] = this.name;
        data["order"] = this.order;
        data["condition"] = this.condition;
        data["answerOptionSetId"] = this.answerOptionSetId;
        data["panelId"] = this.panelId;
        data["expression"] = this.expression;
        data["defaultValue"] = this.defaultValue;
        data["readOnly"] = this.readOnly;
        data["isRequired"] = this.isRequired;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["moduleConditions"] = this.moduleConditions;
        data["moduleConditionsV1"] = this.moduleConditionsV1;
        data["relationToWizardConditionOperator"] = this.relationToWizardConditionOperator;
        return data;
    }
}

export interface IUpdateQuestionRequest {
    id: string;
    questionCode: string;
    name: string | undefined;
    order: number | undefined;
    condition: string | undefined;
    answerOptionSetId: string;
    panelId: string;
    expression: string | undefined;
    defaultValue: string | undefined;
    readOnly: boolean;
    isRequired: boolean;
    regardingObjectTypeId: string | undefined;
    moduleConditions: string | undefined;
    moduleConditionsV1: string | undefined;
    relationToWizardConditionOperator: string | undefined;
}

export class UpdateQuestionTranslationRequest implements IUpdateQuestionTranslationRequest {
    id!: string;
    title!: string | undefined;
    descriptionShort!: string | undefined;
    descriptionLong!: string | undefined;
    language!: string | undefined;
    questionId!: string;
    referenceDisplayText!: string | undefined;
    reference!: string | undefined;

    constructor(data?: IUpdateQuestionTranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.descriptionShort = _data["descriptionShort"];
            this.descriptionLong = _data["descriptionLong"];
            this.language = _data["language"];
            this.questionId = _data["questionId"];
            this.referenceDisplayText = _data["referenceDisplayText"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): UpdateQuestionTranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionTranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["descriptionShort"] = this.descriptionShort;
        data["descriptionLong"] = this.descriptionLong;
        data["language"] = this.language;
        data["questionId"] = this.questionId;
        data["referenceDisplayText"] = this.referenceDisplayText;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IUpdateQuestionTranslationRequest {
    id: string;
    title: string | undefined;
    descriptionShort: string | undefined;
    descriptionLong: string | undefined;
    language: string | undefined;
    questionId: string;
    referenceDisplayText: string | undefined;
    reference: string | undefined;
}

export class UpdateRoleRequest implements IUpdateRoleRequest {
    id!: string;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateRoleRequest {
    id: string;
    name: string | undefined;
    description: string | undefined;
}

export class UpdateSectionRequest implements IUpdateSectionRequest {
    id!: string;
    name!: string;
    icon!: string | undefined;
    order!: number;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IUpdateSectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.order = _data["order"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["order"] = this.order;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSectionRequest {
    id: string;
    name: string;
    icon: string | undefined;
    order: number;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class UpdateSectionTranslationRequest implements IUpdateSectionTranslationRequest {
    id!: string;
    sectionId!: string;
    nameShort!: string | undefined;
    descriptionShort!: string | undefined;
    language!: string | undefined;

    constructor(data?: IUpdateSectionTranslationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectionId = _data["sectionId"];
            this.nameShort = _data["nameShort"];
            this.descriptionShort = _data["descriptionShort"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UpdateSectionTranslationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSectionTranslationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectionId"] = this.sectionId;
        data["nameShort"] = this.nameShort;
        data["descriptionShort"] = this.descriptionShort;
        data["language"] = this.language;
        return data;
    }
}

export interface IUpdateSectionTranslationRequest {
    id: string;
    sectionId: string;
    nameShort: string | undefined;
    descriptionShort: string | undefined;
    language: string | undefined;
}

export class UpdateTasksRequest implements IUpdateTasksRequest {
    id!: string;
    responsibleIds!: string[] | undefined;
    dueTime!: string;
    actualDueDate!: dayjs.Dayjs;
    subject!: string | undefined;
    description!: string | undefined;
    updateSeries!: boolean;
    progression!: string | undefined;
    progressPercentage!: number;
    approvalFlowId!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;

    constructor(data?: IUpdateTasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["responsibleIds"])) {
                this.responsibleIds = [] as any;
                for (let item of _data["responsibleIds"])
                    this.responsibleIds!.push(item);
            }
            this.dueTime = _data["dueTime"];
            this.actualDueDate = _data["actualDueDate"] ? dayjs(_data["actualDueDate"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.updateSeries = _data["updateSeries"];
            this.progression = _data["progression"];
            this.progressPercentage = _data["progressPercentage"];
            this.approvalFlowId = _data["approvalFlowId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.responsibleIds)) {
            data["responsibleIds"] = [];
            for (let item of this.responsibleIds)
                data["responsibleIds"].push(item);
        }
        data["dueTime"] = this.dueTime;
        data["actualDueDate"] = this.actualDueDate ? this.actualDueDate.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["updateSeries"] = this.updateSeries;
        data["progression"] = this.progression;
        data["progressPercentage"] = this.progressPercentage;
        data["approvalFlowId"] = this.approvalFlowId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTasksRequest {
    id: string;
    responsibleIds: string[] | undefined;
    dueTime: string;
    actualDueDate: dayjs.Dayjs;
    subject: string | undefined;
    description: string | undefined;
    updateSeries: boolean;
    progression: string | undefined;
    progressPercentage: number;
    approvalFlowId: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
}

export class UpdateTasksRequestV2 implements IUpdateTasksRequestV2 {
    id!: string;
    responsibleIds!: string[] | undefined;
    dueTime!: string;
    actualDueDate!: dayjs.Dayjs;
    subject!: string | undefined;
    description!: string | undefined;
    updateSeries!: boolean;
    progression!: string | undefined;
    progressPercentage!: number;
    approvalFlowId!: string | undefined;
    customFieldValues!: CustomFieldValues[] | undefined;
    taskEntitiesList!: TaskEntities[] | undefined;

    constructor(data?: IUpdateTasksRequestV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["responsibleIds"])) {
                this.responsibleIds = [] as any;
                for (let item of _data["responsibleIds"])
                    this.responsibleIds!.push(item);
            }
            this.dueTime = _data["dueTime"];
            this.actualDueDate = _data["actualDueDate"] ? dayjs(_data["actualDueDate"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.updateSeries = _data["updateSeries"];
            this.progression = _data["progression"];
            this.progressPercentage = _data["progressPercentage"];
            this.approvalFlowId = _data["approvalFlowId"];
            if (Array.isArray(_data["customFieldValues"])) {
                this.customFieldValues = [] as any;
                for (let item of _data["customFieldValues"])
                    this.customFieldValues!.push(CustomFieldValues.fromJS(item));
            }
            if (Array.isArray(_data["taskEntitiesList"])) {
                this.taskEntitiesList = [] as any;
                for (let item of _data["taskEntitiesList"])
                    this.taskEntitiesList!.push(TaskEntities.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTasksRequestV2 {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTasksRequestV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.responsibleIds)) {
            data["responsibleIds"] = [];
            for (let item of this.responsibleIds)
                data["responsibleIds"].push(item);
        }
        data["dueTime"] = this.dueTime;
        data["actualDueDate"] = this.actualDueDate ? this.actualDueDate.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["updateSeries"] = this.updateSeries;
        data["progression"] = this.progression;
        data["progressPercentage"] = this.progressPercentage;
        data["approvalFlowId"] = this.approvalFlowId;
        if (Array.isArray(this.customFieldValues)) {
            data["customFieldValues"] = [];
            for (let item of this.customFieldValues)
                data["customFieldValues"].push(item.toJSON());
        }
        if (Array.isArray(this.taskEntitiesList)) {
            data["taskEntitiesList"] = [];
            for (let item of this.taskEntitiesList)
                data["taskEntitiesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTasksRequestV2 {
    id: string;
    responsibleIds: string[] | undefined;
    dueTime: string;
    actualDueDate: dayjs.Dayjs;
    subject: string | undefined;
    description: string | undefined;
    updateSeries: boolean;
    progression: string | undefined;
    progressPercentage: number;
    approvalFlowId: string | undefined;
    customFieldValues: CustomFieldValues[] | undefined;
    taskEntitiesList: TaskEntities[] | undefined;
}

export class UpdateTasksStatusRequest implements IUpdateTasksStatusRequest {
    id!: string;
    tasksStatus!: number;
    progressPercentage!: number;

    constructor(data?: IUpdateTasksStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tasksStatus = _data["tasksStatus"];
            this.progressPercentage = _data["progressPercentage"];
        }
    }

    static fromJS(data: any): UpdateTasksStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTasksStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tasksStatus"] = this.tasksStatus;
        data["progressPercentage"] = this.progressPercentage;
        return data;
    }
}

export interface IUpdateTasksStatusRequest {
    id: string;
    tasksStatus: number;
    progressPercentage: number;
}

export class UpdateTeamRequest implements IUpdateTeamRequest {
    id!: string;
    name!: string | undefined;
    description!: string | undefined;
    email!: string | undefined;

    constructor(data?: IUpdateTeamRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateTeamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateTeamRequest {
    id: string;
    name: string | undefined;
    description: string | undefined;
    email: string | undefined;
}

export class UpdateUserApprovalFlowHistoryRequest implements IUpdateUserApprovalFlowHistoryRequest {
    id!: string;
    regardingObjectId!: string;
    comments!: string | undefined;

    constructor(data?: IUpdateUserApprovalFlowHistoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): UpdateUserApprovalFlowHistoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserApprovalFlowHistoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regardingObjectId"] = this.regardingObjectId;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IUpdateUserApprovalFlowHistoryRequest {
    id: string;
    regardingObjectId: string;
    comments: string | undefined;
}

export class UpdateUserSettingRequest implements IUpdateUserSettingRequest {
    userID!: string;
    landOnDashBoard!: boolean;

    constructor(data?: IUpdateUserSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.landOnDashBoard = _data["landOnDashBoard"];
        }
    }

    static fromJS(data: any): UpdateUserSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["landOnDashBoard"] = this.landOnDashBoard;
        return data;
    }
}

export interface IUpdateUserSettingRequest {
    userID: string;
    landOnDashBoard: boolean;
}

export class UserClaimDto implements IUserClaimDto {
    id!: string;
    name!: string | undefined;
    regardingObjectTypeId!: string;
    sectionId!: string | undefined;
    scope!: ClaimScope;
    action!: ClaimActionType;

    constructor(data?: IUserClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.sectionId = _data["sectionId"];
            this.scope = _data["scope"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): UserClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["sectionId"] = this.sectionId;
        data["scope"] = this.scope;
        data["action"] = this.action;
        return data;
    }
}

export interface IUserClaimDto {
    id: string;
    name: string | undefined;
    regardingObjectTypeId: string;
    sectionId: string | undefined;
    scope: ClaimScope;
    action: ClaimActionType;
}

export class UserOrganization implements IUserOrganization {
    organizationId!: string;
    b2CId!: string;
    userEmail!: string | undefined;
    userId!: string;
    isDefault!: boolean;
    isFavorite!: boolean;
    isPartner!: boolean;
    isPartnerFavourite!: boolean;
    defaultLanguage!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    vat!: string | undefined;
    address!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    fiscalYear!: string | undefined;
    releasePhase!: number;
    logo!: string | undefined;
    dbConnectionString!: string | undefined;
    reportName!: string | undefined;
    templateOrganization!: string | undefined;
    invoiceNumber!: string | undefined;
    licenseExpirationDate!: dayjs.Dayjs;
    isTemplate!: boolean;
    isActive!: boolean;
    partnerId!: string | undefined;
    companyId!: string;
    configuration!: string | undefined;

    constructor(data?: IUserOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.b2CId = _data["b2CId"];
            this.userEmail = _data["userEmail"];
            this.userId = _data["userId"];
            this.isDefault = _data["isDefault"];
            this.isFavorite = _data["isFavorite"];
            this.isPartner = _data["isPartner"];
            this.isPartnerFavourite = _data["isPartnerFavourite"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.vat = _data["vat"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.fiscalYear = _data["fiscalYear"];
            this.releasePhase = _data["releasePhase"];
            this.logo = _data["logo"];
            this.dbConnectionString = _data["dbConnectionString"];
            this.reportName = _data["reportName"];
            this.templateOrganization = _data["templateOrganization"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.licenseExpirationDate = _data["licenseExpirationDate"] ? dayjs(_data["licenseExpirationDate"].toString()) : <any>undefined;
            this.isTemplate = _data["isTemplate"];
            this.isActive = _data["isActive"];
            this.partnerId = _data["partnerId"];
            this.companyId = _data["companyId"];
            this.configuration = _data["configuration"];
        }
    }

    static fromJS(data: any): UserOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["b2CId"] = this.b2CId;
        data["userEmail"] = this.userEmail;
        data["userId"] = this.userId;
        data["isDefault"] = this.isDefault;
        data["isFavorite"] = this.isFavorite;
        data["isPartner"] = this.isPartner;
        data["isPartnerFavourite"] = this.isPartnerFavourite;
        data["defaultLanguage"] = this.defaultLanguage;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["vat"] = this.vat;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["fiscalYear"] = this.fiscalYear;
        data["releasePhase"] = this.releasePhase;
        data["logo"] = this.logo;
        data["dbConnectionString"] = this.dbConnectionString;
        data["reportName"] = this.reportName;
        data["templateOrganization"] = this.templateOrganization;
        data["invoiceNumber"] = this.invoiceNumber;
        data["licenseExpirationDate"] = this.licenseExpirationDate ? this.licenseExpirationDate.toISOString() : <any>undefined;
        data["isTemplate"] = this.isTemplate;
        data["isActive"] = this.isActive;
        data["partnerId"] = this.partnerId;
        data["companyId"] = this.companyId;
        data["configuration"] = this.configuration;
        return data;
    }
}

export interface IUserOrganization {
    organizationId: string;
    b2CId: string;
    userEmail: string | undefined;
    userId: string;
    isDefault: boolean;
    isFavorite: boolean;
    isPartner: boolean;
    isPartnerFavourite: boolean;
    defaultLanguage: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    vat: string | undefined;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    fiscalYear: string | undefined;
    releasePhase: number;
    logo: string | undefined;
    dbConnectionString: string | undefined;
    reportName: string | undefined;
    templateOrganization: string | undefined;
    invoiceNumber: string | undefined;
    licenseExpirationDate: dayjs.Dayjs;
    isTemplate: boolean;
    isActive: boolean;
    partnerId: string | undefined;
    companyId: string;
    configuration: string | undefined;
}

export class Validator implements IValidator {
    type!: string | undefined;

    constructor(data?: IValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Validator {
        data = typeof data === 'object' ? data : {};
        let result = new Validator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }
}

export interface IValidator {
    type: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

interface MyAxiosRequestConfig extends Omit<AxiosRequestConfig, "headers"> {
    headers?: any; // this was "any" at v0.21.1 but now broken between 0.21.4 >= 0.27.2
        // Lets make it any again to make it work again.
}